import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "../../components/SoftButton";
import SoftInput from "../../components/SoftInput";
import CloseIcon from '@mui/icons-material/Close';
import SoftProfile from "../../components/ProfilePictures/SoftProfile";
import { useTheme, Dialog, DialogContent, DialogActions, Divider, Collapse, Switch, Grow, Button} from '@mui/material';
import { useNavigate, useSearchParams } from "react-router-dom";
import KpiSubmissionFormBuilder from "../../components/FormBuilder/KpiSubmission";
import { useForm } from "react-hook-form";
import { UseSelectedWorkspace } from "../../hooks/company";
import { KPI_TYPES, KPI_KINDS } from "../../constants/kpi";
import SoftDialog from "../../components/SoftConfirmationDialog";
import CheckIcon from "@mui/icons-material/Check"; 
import WEBHOOK_LOGO_URL from "../../img/webhookIcon.png";
import YetiMode from "../../img/yetiMode.svg";
import SoftSelect from "../../components/SoftSelect";
import { anchorPointTypes, calculationOptions } from "../../components/WorkspaceKpi/metrics/CustomerMetricsType/Dialogs/utils/constants";
import useIntegratedMetricsData from "../AccountSettings/AccountSettingsV2/hooks/useIntegratedMetricsData";
import SoftBox from "../../components/SoftBox";
import ExploreTypes from "../../components/WorkspaceKpi/metrics/CustomerMetricsType/ExploreTypes";
import { formatNumber } from "../../helpers/formatter";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PageHeader from "../../components/PageHeader";
import ozLoader30 from "../../img/loader30.gif"; 
import ozLoader60 from "../../img/loader60.gif"; 
import ozLoader100 from "../../img/loader100.gif"; 
import ozLoaderText from "../../img/ozLoaderContent.png"; 
import ozLoaderText60 from "../../img/ozLoaderText60v3.png"; 
import ozLoaderText100 from "../../img/ozLoaderText100v3.png"; 


import {
  GET_APP_INTEGRATIONS,
  GET_KPI_INTEGRATIONS_BY_DATASET,
  GET_COMPANY_INTEGRATIONS,
} from "../../api/integration";
import {
  GET_ZAPS,
  GET_USER as GET_ZAPIER_USER,
} from "../../api/integrations/zapier";
import { GMB_LOGO_URL } from "../../constants/branding";
import { UseGroupKpis, UseMyKpis, UseDraftKpis, useCustomKpiCreate, useWorkspaceKpiUpdate } from "../../hooks/kpi";
import ConnectedApplications from "../../components/WorkspaceKpi/ConnectedApplications";
import { FETCH_GROUP_TYPE } from "../../api/group";
import { startCase } from "lodash";
import {
  FORM_CONFIGS,
  FORM_OPTIONS_ANCHOR,
} from "../../components/WorkspaceKpi/form/formOptions";
import { lineHeight, textTransform } from "@mui/system";

const ExploreCustomMetricsTypes = () => {

  const navigate = useNavigate();
  const { _id: groupId } = UseSelectedWorkspace();
  const [ismetricType, setIsMetricType] = useState("");
  const [metricName, setmetricName] = useState("");
  const [openDialog, setopenDialog] = useState(false);
  const [openDSDialog, setopenDSDialog] = useState(false);
  const [advancedPopup, setadvancedPopup] = useState(false);
  const [openManualSubmissionDialog, setOpenManualSubmissionDialog] = useState(false);
  const [effectType, setEffectType] = useState();
  const [valueType, setValueType] = useState("");
  const [formIdx, setFormIdx] = useState(0);
  const [inputs, setInputs] = useState([]);
  const [isStep, setStep] = useState(0);
  const [anchorPoint, setAnchorPoint] = useState(1);
  const [unit, setUnit] = useState(1);
  const [anchorType, setAnchorType] = useState("percentage");
  const [dataSource, setDataSource] = useState(null);
  const [sourceId, setSourceId] = useState(null);
  const [sourceLabel, setSourceLabel] = useState(null);
  const [sourceType, setSourceType] = useState(null);
  const [integrationId, setIntegrationId] = useState(null);
  const [kpiModelId, setKpiModelId] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [isSaved, setisSaved] = useState(false);
  const { createCustomKpi } = useCustomKpiCreate();
  const [benchmarkPoint, setBenchmarkPoint] = useState(1);
  const [aboveBenchmark, setAboveBenchmark] = useState(1);
  const [belowBenchmark, setBelowBenchmark] = useState(1);
  const screenWidth = window.innerWidth;
  const [isMonitorMode, setIsMonitorMode] = useState(false);

  // get in param data-metric
  const params = new URLSearchParams(window.location.search);
  const dataMetric = params.get("data-metric");
  useEffect(() => {
    if (dataMetric) {
      setStep(1);
      setIsMetricType("Progressive Metric");
    }
  }, [dataMetric]);

  const [activeIntegrated, setActiveIntegrated] = useState(false);

  const [dialog, setDialog] = useState(false);
  const closeDialog = () => setDialog(false);
  const [saveDialog, setsaveDialog] = useState(false);
  const closesaveDialog = () => setsaveDialog(false);
  const [submitPopup, setSubmitPopup] = useState(false);
  const closeSubmitDialog = () => setSubmitPopup(false);
  const { updateWorkspaceKpi } = useWorkspaceKpiUpdate();

  const { filteredApps } = useIntegratedMetricsData(true);
  const userKpis = UseMyKpis();

  const theme = useTheme();
  const {
    primary: { main: primaryColor },
  } = theme.palette;

  const { setValue: setFormValue, getValues, watch } = useForm();

  const getKindSymbolIndex = (anchorLabel) => {
    if (anchorLabel === anchorPointTypes[1].value) return 0;
    if (anchorLabel === anchorPointTypes[2].value) return 1;
    if (anchorLabel === anchorPointTypes[0].value) return 2;
  };

  const handleKindSelect = (idx) => {
    setFormValue("kind", KPI_KINDS[idx]);
  };

  const getDefaultValue = () => {
    return anchorPointTypes[0];
  };

  const handleInputs = (values) => {
    // Update both react-hook-form inputs and state inputs;
    // Relying on react-hook-form inputs alone does not trigger re-render when values change
    if (values && values.length) {
      setFormValue("inputs", [...values]);
      setInputs([...values]);
    } else {
      setFormValue("inputs", []);
      setInputs([]);
    }
  };

  const handleFormSelect = (idx) => {
    setFormIdx(idx);
  };

  const handleMetricTypeSelect = (metricTitle) => {
    setIsMetricType(metricTitle);
    setopenDialog(false);
    setStep(1);
  };

  const [targetValue, setValue] = useState(1);
  const [psValue, setPsValue] = useState(1);
  const [pValue, setPValue] = useState(1);

  const inputLabel = {
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: screenWidth <= 1280 ? "12px" : "16px",
    lineHeight: '21px',
    color: '#000000',
  };

  const inputFieldStyles = {
    padding: "12px 20px",
    background: "#FFFFFF",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    borderRadius: "4px",
    marginTop: "-0.5rem",
    marginBottom: "0.25rem",
    "& input": {
      fontFamily: "DM Sans",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "14px",
      color: "#000000",
    },
    "&.Mui-focused": {
      border: `1px solid ${primaryColor}`,
      boxShadow: "none!important"
    }
  };

  const [allApps, setAllApps] = useState([]);
  const [integrationsObj, setIntegrationsObj] = useState(null);
  const [currentAppIntegrations, setCurrentAppIntegrations] = useState({});
  const [connectedApps, setConnectedApps] = useState([]);
  const [newKpi, setNewKpi] = useState(null);
  const [currentGroupKpis, setCurrentGroupKpis] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  const groupKpis = UseGroupKpis(); // Assuming you have this hook available
  const draftKpis = UseDraftKpis();
  const watchAdvanced = watch("advanced");


  const [searchParams] = useSearchParams();
  const kpiIdParam = searchParams.get("kpiid");
  const [metricData, setMetricData] = useState(null);
  useEffect(() => {
    if(kpiIdParam){
      setStep(1);
      const metricDatas = (groupKpis && groupKpis.find(kpi => kpi._id === kpiIdParam)) ||
                          (draftKpis && draftKpis.find(kpi => kpi._id === kpiIdParam));

      if(!metricDatas.metricType && metricDatas.optional && metricDatas.optional.unit){
        setIsMetricType("Anchor Metric");
      }else{
        setIsMetricType("Progressive Metric");
      }
      if(metricDatas.metricType){
        setIsMetricType(metricDatas.metricType.charAt(0).toUpperCase() + metricDatas.metricType.slice(1) + " Metric");
      }
      setIsDraft(false);
      setMetricData(metricDatas);
      setValue(metricDatas.target);
      setPsValue(metricDatas.pointScale);
      setPValue(metricDatas.pointValue);
      setValueType(metricDatas.kind);
      setEffectType(metricDatas.direction);
      setFormValue("advanced", "checked");
      setmetricName(metricDatas.title);

      if(metricDatas && metricDatas.metricType === "anchor"){
        setBenchmarkPoint(metricDatas.optional.benchmarkPoint);
        setAboveBenchmark(metricDatas.optional.aboveBenchmark);
        setBelowBenchmark(metricDatas.optional.belowBenchmark);
        if (metricDatas.kind === "%") {
          setAnchorPoint(metricDatas.target * 100);
          setUnit(metricDatas.optional.unit * 100);
        } else {
          setAnchorPoint(metricDatas.target);
          setUnit(metricDatas.optional.unit);
        }
      }
    }
  }, [kpiIdParam, groupKpis, setFormValue]);

  const workspace = UseSelectedWorkspace(); // Assuming you have this hook available
  const { data: workspaceData } = FETCH_GROUP_TYPE(workspace?.typeId);

    const addZapierKpis = async (appsData) => {
    try {
      setIsLoading(true);
      // Don't let GET_ZAPIER_USER failure break the list (e.g. server deleted integration or token expired)
      const [zapTemplatesResponse, zapUserResponse] = await Promise.all([
        GET_ZAPS(),
        GET_ZAPIER_USER().catch(() => ({ data: null })),
      ]);
  
      const zapTemplates = zapTemplatesResponse.data;
      const zapUser = zapUserResponse?.data ?? null;
      const isZapierConnected = zapUser && !zapUser.tokenExpired;
  
      zapTemplates.forEach((z) => {
        const idx = appsData.findIndex((app) => app.name === z.name);
        z.isConnected = !!isZapierConnected;
  
        const zaps = z.zaps.map((zap) => ({
          ...zap,
          id: z.serviceId,
          integrationId: z._id,
          description: zap.description.replace("Game My Biz", ""),
          isZapier: true,
        }));
  
        if (idx >= 0) {
          appsData[idx].zaps = zaps;
        } else {
          appsData.push({
            ...z,
            zaps,
          });
        }
      });
  
      setTimeout(() => setIsLoading(false), 500);
      return appsData;
    } catch (err) {
      console.log("zap templates err", err);
      return appsData;
    }
  };

  useEffect(() => {
    if (metricData?.requiredInputs) {
      if (metricData.requiredInputs.length === 1) {
        // Single-input form
        const singleInput = metricData.requiredInputs[0];
        if (singleInput.type === FORM_CONFIGS.image.type) {
          setFormIdx(FORM_CONFIGS.image.index);
        } else if (singleInput.type === FORM_CONFIGS.link.type) {
          setFormIdx(FORM_CONFIGS.link.index);
        } else {
          setFormIdx(FORM_CONFIGS.text.index);
        }
      } else {
        // Custom-input form (can be single or multiple inputs)
        setFormIdx(3);
      }
      setInputs([
        ...metricData.requiredInputs.map((input) => ({
          ...input,
          value: input.type === "notification_settings" ? input.value : startCase(input.value),
        })),
      ]);
    }
  }, [metricData?.requiredInputs]);

  // Add this useEffect to handle apps data loading
  useEffect(() => {
    if (workspaceData) {
      const getIntegrationsData = async () => {
        const [appsResponse, integResponse, companyIntegrationsResponse] =
          await Promise.all([
            GET_APP_INTEGRATIONS(),
            GET_KPI_INTEGRATIONS_BY_DATASET(),
            GET_COMPANY_INTEGRATIONS(),
          ]);

        let appsData = appsResponse.data;
        const integData = integResponse.data;
        const companyIntegrations = companyIntegrationsResponse.data;

        for (let j = 0; j < appsData.length; j += 1) {
          const { code, serviceId } = appsData[j];
          const idx = companyIntegrations.findIndex((app) => {
            return serviceId ? app.serviceId === serviceId : app.code === code;
          });
          if (idx >= 0) {
            appsData[j].isConnected = true;
            appsData[j].paramKeys = { ...companyIntegrations[idx].parameters };
          } else {
            appsData[j].isConnected = false;
          }
        }
        appsData = await addZapierKpis(appsData);

        appsData.push({
          name: "Game My Biz",
          code: "manual",
          logo: GMB_LOGO_URL,
          description: "Custom-built metrics for your business",
          isConnected: true,
          isManual: true,
          models: workspaceData?.data.map((model) => {
            const { _id, ...rest } = model;
            return {
              kpiModelId: _id,
              ...rest,
            };
          }),
        });

        appsData.push({
          name: "Webhook",
          code: "webhook",
          logo: WEBHOOK_LOGO_URL,
          description: "All payloads available",
          isConnected: true,
          isWebhook: true,
          models: []
        });

        const appsConnected = appsData.filter(
          (item) => item.isConnected === true
        );

        // Sort apps: connected ones first then sort alphabetically
        const sortedApps = appsData.sort((app1, app2) => {
          if (app1.isConnected && !app2.isConnected) return -1;
          if (!app1.isConnected && app2.isConnected) return 1;
          if (!app1.isZapier && app2.isZapier) return -1;
          if (app1.isZapier && !app2.isZapier) return 1;
          if (!app1.isManual && app2.isManual) return -1;
          if (app1.isManual && !app2.isManual) return 1;
          return app1.name.localeCompare(app2.name);
        });

        setConnectedApps(appsConnected);
        setAllApps(sortedApps);
        setIntegrationsObj(integData);
        setIsLoading(false);
      };

      getIntegrationsData();
    }
  }, [workspaceData]);

  // Add this useEffect to handle integrations
  useEffect(() => {
    if (groupKpis) {
      const appIntegrations = {};
      groupKpis
        .filter((kpi) => kpi.integrationId)
        .forEach((kpi) => {
          (appIntegrations[kpi.integrationId] ??= []).push(kpi.sourceId);
        });

      setCurrentAppIntegrations(appIntegrations);
    }
  }, [groupKpis]);

  useEffect(() => {
    if (groupKpis) {
      const appIntegrations = {};
      groupKpis
        .filter((kpi) => kpi.integrationId)
        .forEach((kpi) => {
          (appIntegrations[kpi.integrationId] ??= []).push(kpi.sourceId);
        });

      setCurrentAppIntegrations(appIntegrations);

      // Find the newly-added Integrated GroupKpi
      setCurrentGroupKpis(prev => {
        const groupKpiIds = groupKpis.map(kpi => kpi._id);

        if (Array.isArray(prev)) {
          const newGroupKpiId = groupKpiIds.filter(id => !prev.includes(id))?.[0];
          const newGroupKpi = groupKpis.find(kpi => kpi._id === newGroupKpiId);

          // Full newly-saved "display" GroupKpi data from server
          if (newGroupKpi?._id && groupKpis.length > 0) {
            setNewKpi(prevKpi => {
              if (prevKpi?.isNew) {
                setActiveIntegrated(true);
              }
              return { ...prevKpi, ...newGroupKpi }
             });
          }
        }

        return groupKpiIds;
      });
    }
  }, [groupKpis]);

  const submitData = () => {
    let requiredInputs = [];

    if (inputs && inputs.length) {
      requiredInputs = inputs.map((el) => {
        // Extract only valid elements; it may have extra values from Form Builder
        const { type: inputType, value, desc, enabled } = el;
        
        // For notification settings, include both enabled state and email value
        if (inputType === 'notification_settings') {
          return {
            type: inputType,
            value: value || '',
            enabled: enabled || false,
            desc
          };
        }

        // For all other input types
        return {
          type: inputType,
          value: value.toLowerCase().replace(" ", "_"),
          desc,
          // Dropdown inputs carry their admin-defined choices.
          ...(inputType === "dropdown" && el.options?.length ? { options: el.options } : {}),
        };
      });
    }

    let kpiData = {};

    if(ismetricType === "Anchor Metric"){
      let targetData = anchorPoint;
      let unitData = unit;
  
      if (valueType === "percentage") {
        targetData = parseFloat(anchorPoint) / 100;
        unitData = parseFloat(unit) / 100;
      }

      kpiData = {
        name: metricName,
        kind: (valueType === "dollar" || "$") ||
              (valueType === "percentage" || "%") ||
              (valueType === "item" || "#") ||
              (isDraft && "#"),
        direction: isDraft ? 1 : effectType,
        target: isDraft ? "1" : parseFloat(targetData),
        unit: parseFloat(unitData),
        gap: true,
        point: isDraft ? "0" : parseFloat(aboveBenchmark),
        benchmarkPoint: parseFloat(benchmarkPoint),
        aboveBenchmark: parseFloat(aboveBenchmark),
        belowBenchmark: parseFloat(belowBenchmark),
        anchorType: valueType,
        percentageAnchorValue: 0,
        restAnchorValue: 0,
        advanced: getValues("advanced"),
        dataSourceOne: getValues("dataSourceOne"),
        calculationMethod: getValues("calculationMethod"),
        dataSourceTwo: getValues("dataSourceTwo"),
        isDraft,
        webhook: false,
        groupId,
        metricType: KPI_TYPES[1],
        ...(requiredInputs.length && { requiredInputs }),
      };
    }
    if (ismetricType === "Progressive Metric"){
      kpiData = {
        name: metricName,
        kind: isDraft ? "#" : valueType,
        direction: isDraft ? 1 : effectType,
        target: isDraft ? "1" : targetValue,
        pointScale: isDraft ? "0" : psValue,
        pointValue: isDraft ? "0" : pValue,
        advanced: getValues("advanced"),
        dataSourceOne: getValues("dataSourceOne"),
        calculationMethod: getValues("calculationMethod"),
        dataSourceTwo: getValues("dataSourceTwo"),
        isDraft,
        webhook: false,
        groupId,
        metricType: KPI_TYPES[0],
        ...(isSaved ? { requiredInputs: [{ type: "text", value: "none" }] } : requiredInputs.length && { requiredInputs }),
      };
    }
    if (ismetricType === "Display Metric"){ 
      kpiData = {
        target: 0,
        pointScale: 0,
        direction: 1,
        metricType: KPI_TYPES[2],
        groupId,
        name: metricName,
        kind: isDraft ? "#" : valueType,
        dataSource,
        sourceId,
        integrationId,
        kpiModelId,
        webhook: false,
        ...(isSaved ? { requiredInputs: [{ type: "text", value: "none" }] } : requiredInputs.length && { requiredInputs }),
      };
    }

    // Save the edited Integrated Display metric as an Integrated Anchor or Progressive metric
    // Note: Only offer to edit/change a Display Metric to an Anchor or Progressive only right after creating it
    if(newKpi && metricData === null){
      const newKpiData = {
        type: newKpi.type,
        description: newKpi.description,
        app: newKpi.app,
        logo: newKpi.logo,
        code: newKpi.code,
        sourceId: newKpi.sourceId,
        integrationId: newKpi.integrationId,
        isConnected: newKpi.isConnected,
        isNew: newKpi.isNew,
        _id: newKpi._id,
        kpiModelId: newKpi.kpiModelId,
        direction: newKpi.direction,
        source: newKpi.source,
        sourceName: newKpi.sourceName,
        minimum: newKpi.minimum,
        parameters: newKpi.parameters,
      };

      kpiData = {
        ...kpiData,
        ...newKpiData,
        ...(dataMetric ? { isDraft: true, isSaved: true } : {})
      };
      updateWorkspaceKpi(groupId, kpiData);
      if (newKpi.isZapier && newKpi.integrationMeta) {
        navigate(`/zapier-setup?id=${newKpi.integrationMeta.id}`);
      } else {
        // Fake success notification that appears after a short delay (and not when data has been successfully processed)
        setTimeout(() => {
          setDialog(true);
        }, 1500);

      }
    }

    if (metricData){ 
      kpiData = {
        pointScale: psValue,
        direction: effectType,
        name: metricName,
        title: metricData.title,
        metricType: metricData.metricType,
      };
      if(metricData.metricType === "progressive" || ismetricType === "Progressive Metric"){
        metricData.target = targetValue;
        metricData.pointScale = psValue;
        metricData.pointValue = pValue;
      }
      if(metricData.metricType === "anchor" || ismetricType === "Anchor Metric"){
        let targetData = anchorPoint;
        let unitData = unit;
        if (anchorType === "percentage") {
          targetData = parseFloat(anchorPoint) / 100;
          unitData = parseFloat(unit) / 100;
        }
        metricData.unit = parseFloat(unitData);
        metricData.target = targetData;
        metricData.point = isDraft ? "0" : parseFloat(aboveBenchmark);
        metricData.benchmarkPoint = benchmarkPoint;
        metricData.aboveBenchmark = aboveBenchmark;
        metricData.belowBenchmark = belowBenchmark;
      }else{
        kpiData.target = targetValue;
      }
      const originalInputs = metricData.requiredInputs;
      const hasQuickCapture = originalInputs?.some(i => i.type === 'quick-capture');
      const kpiRaw = {
        ...kpiData,
        ...metricData,
        groupId,
        isCustom: true,
        ...(hasQuickCapture
          ? { requiredInputs: originalInputs }
          : requiredInputs.length && { requiredInputs }),
      };
      updateWorkspaceKpi(groupId, kpiRaw);
      setTimeout(() => {
        setDialog(true);
      }, 1500);
    }

    if (metricData === null && !newKpi){ 
      createCustomKpi(kpiData);
      setTimeout(() => {
        setDialog(true);
      }, 1500);
    }
  }

  const [mergedKpis, setMergedKpis] = useState([]);

  useEffect(() => {
    if (draftKpis && groupKpis) {
      const mergedKpisData = [...draftKpis, ...groupKpis];
      setMergedKpis(mergedKpisData);
    }
  }, [draftKpis, groupKpis]);

  const dataSourceOneOptions = [
    { label: "Active", options: [] },
    { label: "Drafts", options: [] }
  ];

  if (metricData && metricData.optional && metricData.optional.sourceId1) {
    const matchedKpi = mergedKpis.find(kpi => kpi._id === metricData.optional.sourceId1);
    if (matchedKpi) {
      const option = {
        value: matchedKpi._id,
        label: `${matchedKpi.title} - ${formatNumber(userKpis?.month[matchedKpi._id]?.amt ?? 0)}`
      };
      dataSourceOneOptions[0].options.push(option);
    }
  }

  mergedKpis
    .sort((a, b) => Number(!!b.isDraft) - Number(!!a.isDraft))
    .forEach((kpi) => {
      const option = {
        value: kpi._id,
        label: `${kpi.title} - ${formatNumber(userKpis?.month[kpi._id]?.amt ?? 0)}`
      };
      
      if (kpi.isDraft) {
        dataSourceOneOptions[1].options.push(option);
      } else {
        dataSourceOneOptions[0].options.push(option);
      }
    });



  const dataSourceTwoOptions = [
    { label: "Active", options: [] },
    { label: "Drafts", options: [] }
  ];

  if (metricData && metricData.optional && metricData.optional.sourceId2) {
    const matchedKpi = mergedKpis.find(kpi => kpi._id === metricData.optional.sourceId2);
    if (matchedKpi) {
      const option = {
        value: matchedKpi._id,
        label: `${matchedKpi.title} - ${formatNumber(userKpis?.month[matchedKpi._id]?.amt ?? 0)}`
      };
      dataSourceTwoOptions[0].options.push(option);
    }
  }

  mergedKpis
    .sort((a, b) => Number(!!b.isDraft) - Number(!!a.isDraft))
    .forEach((kpi) => {
      const option = {
        value: kpi._id,
        label: `${kpi.title} - ${formatNumber(userKpis?.month[kpi._id]?.amt ?? 0)}`
      };
      
      if (kpi.isDraft) {
        dataSourceTwoOptions[1].options.push(option);
      } else {
        dataSourceTwoOptions[0].options.push(option);
      }
    });

    const [ozLoader, setOzLoader] = useState(false);
    const [inputError, setInputError] = useState({});

    const inputChecker = () => {
      setOzLoader(false);

      if (isStep === 3) {
        let hasError = false;
        const newErrors = {};
        if (!effectType) {
          newErrors.effectType = true;
          hasError = true;
        }
        if (!valueType) {
          newErrors.valueType = true;
          hasError = true;
        }
        setInputError(newErrors);
        if (hasError) return;
        submitData();
      } else if (isStep === 2) {
        let hasError = false;
        const newErrors = {};

        if (!metricName) {
          newErrors.metricName = true;
          hasError = true;
        }
        if (!targetValue && ismetricType === "Progressive Metric"){
          newErrors.targetValue = true;
          hasError = true;
        }
        if (!pValue && ismetricType === "Progressive Metric"){
          newErrors.pValue = true;
          hasError = true;
        }
        if (!psValue && ismetricType === "Progressive Metric"){
          newErrors.psValue = true;
          hasError = true;
        }
        if (!anchorPoint && ismetricType === "Anchor Metric") {
          newErrors.anchorPoint = true;
          hasError = true;
        }
        if (!benchmarkPoint && ismetricType === "Anchor Metric") {
          newErrors.benchmarkPoint = true;
          hasError = true;
        }
        if (!belowBenchmark && ismetricType === "Anchor Metric") {
          newErrors.belowBenchmark = true;
          hasError = true;
        }
        if (!aboveBenchmark && ismetricType === "Anchor Metric") {
          newErrors.aboveBenchmark = true;
          hasError = true;
        }

        setInputError(newErrors);

        if (hasError) return;
        setStep(isStep + 1);
      } else if (dataMetric) {
        setStep(3);
      } else {
        setStep(isStep + 1);
      }
    };

  return (
    <>
      <PageHeader
        headerText={`${workspace.name ?? "Workspace"} KPIs`}
        subheaderText="Get real-time insights into your Key Performance Indicators"
      />
      <SoftBox sx={{ margin: { mini: "1rem", sm: "1.5rem" } }}>
        {/* Page Content */}
        <Grid container>
          {isStep === 0 && (
            <Grid item mini={12}>
              <SoftBox>
                <SoftBox
                  sx={{
                    background: "#FFFFFF",
                    borderRadius: "8px",
                    paddingX: screenWidth <= 1280 ? "1rem" : "8rem",
                    paddingY: screenWidth <= 1280 ? "1rem" : "1rem",
                  }}
                >
                  <SoftBox sx={{textAlign: "center", marginTop: "3rem"}}>
                    <SoftTypography
                      sx={{
                        fontWeight: 600,
                        fontSize: "25.4px",
                        lineHeight: "31px",
                        color: "#000000",
                        marginBottom: "0.5rem",
                      }}>Choose a Metric Type</SoftTypography>
                    <SoftTypography
                    sx={{
                      fontWeight: 400,
                      fontSize: "20.4px",
                      lineHeight: "27px",
                      textAlign: "center",
                      letterSpacing: "-0.02em",
                      color: "#98A2B3",
                    }}
                    >
                      Pick the type of metric you want to create. Each type serves a different purpose,<br/> helping you track performance the way you need.
                    </SoftTypography>
                  </SoftBox>
                  <ExploreTypes onMetricTypeSelect={handleMetricTypeSelect}/>
                </SoftBox>
              </SoftBox>
            </Grid>
          )}
          {isStep >= 1 && (
            <Grid item mini={12}>
              <SoftBox>
                <SoftBox
                  sx={{
                    background: "#FFFFFF",
                    borderRadius: "8px",
                    paddingY: screenWidth <= 1280 ? "1rem" : "1rem",
                  }}
                >
                  <SoftBox sx={{paddingX: "2rem", marginBottom: "1rem"}}>
                    <SoftTypography
                      sx={{
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "20px",
                        lineHeight: "24px",
                        color: "#344054",
                        marginTop: "0.5rem",
                        marginBottom: "0.25rem",
                      }}
                    >Create a Custom Metric</SoftTypography>
                    <SoftTypography
                      sx={{
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "16px",
                        lineHeight: "21px",
                        letterSpacing: "-0.02em",
                        color: "#475467",
                      }}
                    >Define a new metric to track performance in a way that suits your team’s goals</SoftTypography>
                  </SoftBox>
                  <Divider
                    sx={{
                      margin: 0,
                      background: "#F2F4F7",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    }}
                  />
                  <SoftBox sx={{ width: "100%", padding: "2rem 0 1.5rem 0" }}>
                    <SoftBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      gap="0rem"
                      sx={{
                        width: dataMetric ? "30%" : "50%",
                        margin: "0 auto",
                        mb: dataMetric ? -3 : 0,
                      }}
                    >
                      {[
                        {
                          title: "Data Source",
                          desc: "Where your metric pulls info from",
                        },
                        // Hide step 2 if dataMetric is truthy
                        ...(!dataMetric
                          ? [{
                              title: "Metric Goal",
                              desc: "What success looks like for this metric",
                            }]
                          : []),
                        {
                          title: "Finalize & Launch",
                          desc: "Define behavior & Go live",
                        },
                      ].map((stepInfo, filteredIdx, arr) => {
                        // The stepNum maps to the original step order (1 or 2 or 3), needed for correct icons/logic.
                        let stepNum;
                        if (!dataMetric) {
                          stepNum = filteredIdx + 1;
                        } else {
                          // If dataMetric is truthy, "Metric Goal" (original index 1) is skipped, so stepNum increments differently:
                          // Index 0 is "Data Source" (stepNum=1), index 1 is "Finalize & Launch" (stepNum=3)
                          stepNum = filteredIdx === 0 ? 1 : 2;
                        }
                        let stepIcon = null;
                        if (stepNum < isStep) {
                          stepIcon = (
                            <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="20.919" cy="20.4187" r="20.4192" fill="url(#paint0_linear_415_5354)"/>
                              <path d="M19.0106 25.5141L13.5448 20.0217L15.4368 18.1204L19.0106 21.7117L26.7047 13.98L28.5967 15.8812L19.0106 25.5141Z" fill="white"/>
                              <defs>
                                <linearGradient id="paint0_linear_415_5354" x1="33.6612" y1="161.93" x2="-9.59248" y2="159.187" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#7928CA"/>
                                  <stop offset="1" stopColor="#FF0080"/>
                                </linearGradient>
                              </defs>
                            </svg>
                          );
                        }
                        else if (stepNum === isStep) {
                          if (stepNum === 1) {
                            stepIcon = (
                              <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20.9193" cy="20.4179" r="17.016" fill="url(#paint0_linear_415_4176)" />
                                <path d="M22.5822 15.2161V25.6113H21.0087V16.7896H20.9478L18.4607 18.4138V16.9114L21.0544 15.2161H22.5822Z" fill="white" />
                                <circle cx="20.9192" cy="20.4173" r="19.7386" stroke="url(#paint1_linear_415_4176)" strokeWidth="1.36128" />
                                <defs>
                                  <linearGradient id="paint0_linear_415_4176" x1="31.5378" y1="138.344" x2="-4.50693" y2="136.058" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#7928CA" />
                                    <stop offset="1" stopColor="#FF0080" />
                                  </linearGradient>
                                  <linearGradient id="paint1_linear_415_4176" x1="33.6614" y1="161.928" x2="-9.5923" y2="159.186" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#7928CA" />
                                    <stop offset="1" stopColor="#FF0080" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            );
                          } else if (stepNum === 2) {
                            stepIcon = (
                              <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20.9194" cy="20.4203" r="17.016" fill="url(#paint0_linear_415_5356)"/>
                                <path d="M17.9521 25.6155V24.4785L21.4696 20.8341C21.8452 20.4382 22.1548 20.0913 22.3985 19.7935C22.6455 19.4924 22.8299 19.2064 22.9517 18.9357C23.0735 18.665 23.1345 18.3774 23.1345 18.0728C23.1345 17.7277 23.0532 17.4299 22.8908 17.1795C22.7284 16.9257 22.5067 16.7311 22.2259 16.5958C21.945 16.457 21.6286 16.3877 21.2767 16.3877C20.9045 16.3877 20.5796 16.4638 20.3022 16.6161C20.0247 16.7684 19.8115 16.9832 19.6626 17.2607C19.5137 17.5382 19.4393 17.863 19.4393 18.2353H17.9419C17.9419 17.6025 18.0874 17.0492 18.3784 16.5755C18.6694 16.1017 19.0687 15.7346 19.5763 15.474C20.0839 15.2101 20.6608 15.0781 21.3072 15.0781C21.9603 15.0781 22.5355 15.2084 23.0329 15.469C23.5337 15.7261 23.9246 16.0781 24.2054 16.5247C24.4863 16.968 24.6267 17.4688 24.6267 18.0272C24.6267 18.4129 24.554 18.7902 24.4085 19.1591C24.2664 19.5279 24.0176 19.939 23.6623 20.3925C23.307 20.8425 22.813 21.389 22.1802 22.032L20.1144 24.1943V24.2704H24.7942V25.6155H17.9521Z" fill="white"/>
                                <circle cx="20.9191" cy="20.4197" r="19.7386" stroke="url(#paint1_linear_415_5356)" strokeWidth="1.36128"/>
                                <defs>
                                  <linearGradient id="paint0_linear_415_5356" x1="31.5379" y1="138.346" x2="-4.50687" y2="136.061" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#7928CA"/>
                                    <stop offset="1" stopColor="#FF0080"/>
                                  </linearGradient>
                                  <linearGradient id="paint1_linear_415_5356" x1="33.6612" y1="161.931" x2="-9.59242" y2="159.188" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#7928CA"/>
                                    <stop offset="1" stopColor="#FF0080"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                            );
                          } else if (stepNum === 3) {
                            stepIcon = (
                              <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20.9191" cy="20.4198" r="17.016" fill="url(#paint0_linear_415_5355)" />
                                <path d="M21.1674 25.7554C20.4703 25.7554 19.8477 25.6353 19.2995 25.395C18.7547 25.1548 18.3233 24.8215 18.0052 24.3951C17.6905 23.9653 17.5213 23.4679 17.4976 22.9028H19.0914C19.1117 23.2107 19.2149 23.4781 19.401 23.7048C19.5905 23.9281 19.8376 24.1007 20.1421 24.2225C20.4467 24.3443 20.785 24.4052 21.1573 24.4052C21.5667 24.4052 21.9288 24.3342 22.2435 24.1921C22.5616 24.0499 22.8103 23.852 22.9896 23.5982C23.169 23.341 23.2587 23.0449 23.2587 22.7099C23.2587 22.3614 23.169 22.0551 22.9896 21.7912C22.8137 21.5239 22.5548 21.3141 22.213 21.1618C21.8747 21.0095 21.4652 20.9334 20.9847 20.9334H20.1066V19.6543H20.9847C21.3705 19.6543 21.7088 19.5849 21.9999 19.4462C22.2943 19.3074 22.5244 19.1146 22.6902 18.8675C22.856 18.6171 22.9389 18.3244 22.9389 17.9894C22.9389 17.668 22.8661 17.3888 22.7206 17.1519C22.5785 16.9117 22.3755 16.7239 22.1115 16.5885C21.851 16.4532 21.543 16.3855 21.1877 16.3855C20.8493 16.3855 20.533 16.4481 20.2386 16.5733C19.9475 16.6951 19.7107 16.8711 19.5279 17.1012C19.3452 17.3279 19.2471 17.6003 19.2335 17.9184H17.7159C17.7328 17.3567 17.8986 16.8626 18.2133 16.4362C18.5314 16.0099 18.951 15.6766 19.4721 15.4363C19.9932 15.1961 20.5719 15.0759 21.208 15.0759C21.8747 15.0759 22.4499 15.2062 22.9338 15.4668C23.4211 15.7239 23.7967 16.0674 24.0606 16.4971C24.328 16.9269 24.4599 17.3973 24.4565 17.9082C24.4599 18.4902 24.2975 18.9843 23.9693 19.3904C23.6444 19.7964 23.2113 20.0688 22.6699 20.2076V20.2888C23.3602 20.3937 23.8948 20.6678 24.2738 21.111C24.6562 21.5543 24.8457 22.1042 24.8423 22.7607C24.8457 23.3326 24.6866 23.8452 24.3652 24.2986C24.0471 24.7521 23.6123 25.1091 23.0607 25.3696C22.5091 25.6268 21.878 25.7554 21.1674 25.7554Z" fill="white"/>
                                <circle cx="20.9194" cy="20.4195" r="19.7386" stroke="url(#paint1_linear_415_5355)" strokeWidth="1.36128"/>
                                <defs>
                                  <linearGradient id="paint0_linear_415_5355" x1="31.5376" y1="138.346" x2="-4.50712" y2="136.06" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#7928CA"/>
                                    <stop offset="1" stopColor="#FF0080"/>
                                  </linearGradient>
                                  <linearGradient id="paint1_linear_415_5355" x1="33.6615" y1="161.93" x2="-9.59213" y2="159.188" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#7928CA"/>
                                    <stop offset="1" stopColor="#FF0080"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                            );
                          }
                        } else {
                          // Default: inactive step
                          stepIcon = (
                            <SoftBox
                              sx={{
                                width: 42,
                                height: 42,
                                background: "#EAEAEA",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 400,
                                fontSize: 17,
                                color: "#fff"
                              }}
                            >
                              {stepNum}
                            </SoftBox>
                          );
                        }

                        const isClickable = stepNum < isStep;
                        const handleStepClick = () => {
                          if (isClickable && typeof setStep === "function") {
                            setStep(stepNum);
                          }
                        };

                        return (
                          <React.Fragment key={stepNum}>
                            <SoftBox
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                              sx={isClickable ? { cursor: 'pointer', opacity: 1 } : {}}
                              onClick={isClickable ? handleStepClick : undefined}
                            >
                              {stepIcon}
                              <SoftBox sx={{ textAlign: "center", position: "absolute", marginTop: "6rem" }}>
                                <SoftTypography variant="subtitle1" sx={{ fontWeight: 600, fontSize: "15px", lineHeight: "20px", color: "#1F2533", mt: 1, textAlign: "center" }}>
                                  {stepInfo.title}
                                </SoftTypography>
                                <SoftTypography variant="caption" sx={{ fontWeight: 400, fontSize: "13px", lineHeight: "18px", color: "#757575", mt: 0.3, textAlign: "center" }}>
                                  {stepInfo.desc}
                                </SoftTypography>
                              </SoftBox>
                            </SoftBox>
                            {/* Render the connecting line between steps, except after the last step */}
                            {filteredIdx < arr.length - 1 && (() => {
                              let backgroundColor = "#EAEAEA";
                              // Since we might have 2 or 3 steps visible, handle logic carefully.
                              // StepNum order: always 1, maybe 2, and always 3.
                              // We want active line only between completed steps, i.e. up to isStep
                              if (isStep === 1) {
                                backgroundColor = "#EAEAEA";
                              } else if (isStep === 2) {
                                // If second step is not rendered (dataMetric), then completion can only be after step 1, not step 2.
                                if (dataMetric) {
                                  backgroundColor = "#EAEAEA";
                                } else if (filteredIdx === 0) {
                                  backgroundColor = "#1F2F61";
                                } else {
                                  backgroundColor = "#EAEAEA";
                                }
                              } else if (isStep === 3) {
                                backgroundColor = "#1F2F61";
                              }
                              return (
                                <SoftBox
                                  sx={{
                                    width: "100%",
                                    height: 2,
                                    background: backgroundColor,
                                    margin: "0!important",
                                    alignSelf: "center",
                                  }}
                                />
                              );
                            })()}
                          </React.Fragment>
                        );
                      })}
                    </SoftBox>
                  </SoftBox>
                  <SoftBox sx={{paddingX: "2rem", marginBottom: "1rem", marginTop: "5rem"}}>
                    <SoftBox 
                    sx={{ 
                      background: "#F9FAFB",
                      border: "1px solid #EAECF0",
                      borderRadius: "8px",
                      width: "40%",
                      margin: "0 auto",
                      padding: "0.75rem 1rem",
                      display:  dataMetric ? "none" : "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    > 
                      <SoftTypography variant="h6" 
                        sx={{ 
                          fontSize: "20px",
                          lineHeight: "26px",
                          color: "#000000",
                          fontWeight: 600,
                        }}
                      >
                        {ismetricType} Setup
                      </SoftTypography>
                      <SoftButton
                        variant="contained"
                        pb={0}
                        pt={0}
                        sx={{
                          textTransform: "none",
                          background: "#FFFFFF",
                          borderRadius: "4px",
                          marginTop: "-0.25rem",
                          padding: "0.25rem 1rem",
                          boxShadow: "none !important",
                          display: ismetricType ? "" : "none"
                        }}
                        onClick={() => setopenDialog(true)}
                      >
                        Change Metric
                      </SoftButton>
                    </SoftBox>
                  </SoftBox>
                  <SoftBox sx={{ width: "100%", padding: "1rem 0 1.5rem 0" }}>
                    <SoftBox display="flex" justifyContent="center" alignItems="center" gap="0rem" sx={{ width: screenWidth > 1280 ? "60%" : "50%", margin: "0 auto" }}>
                        <SoftBox sx={{
                          background: "linear-gradient(273.63deg, rgba(121, 40, 202, 0.1) 0%, rgba(255, 0, 128, 0.1) 100%)",
                          border: "1px solid rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                          width: "100%",
                          height: "100%",
                          padding: "1.5rem",
                        }}> 
                          {isStep === 1 && (
                            <Grid container>
                              <Grid item mini={12} mb={2} textAlign="center">
                                <SoftTypography variant="h2" 
                                  sx={{ 
                                      fontSize: screenWidth <= 1280 ? "14px" : "20px",
                                      fontWeight: 700,
                                      lineHeight: "26px",
                                      textAlign: "center",
                                      color: "#000000",
                                      }}>
                                  Data Source</SoftTypography>
                                <SoftTypography variant="p" 
                                  sx={{ 
                                    fontSize: screenWidth <= 1280 ? "12px" : "14px", 
                                    fontWeight: "500",
                                    lineHeight: "18px",
                                    textAlign: "center",
                                    color: "#667085",
                                  }}>Where your metric pulls info from</SoftTypography>
                              </Grid>
                              <Grid item mini={6} pr={1}>
                                <SoftBox
                                  onClick={() => {
                                    if (!dataMetric) {
                                      setOpenManualSubmissionDialog(true);
                                    }
                                  }}
                                  sx={{
                                      opacity: dataMetric ? 0.5 : 1,
                                      background: "#FFFFFF",
                                      borderRadius: "4px",
                                      padding: screenWidth <= 1280 ? "1rem 0.5rem 1rem 0.5rem" : "2rem",
                                      textAlign: "center",
                                  }}
                                >
                                  <SoftBox>
                                    {inputs && inputs.length > 0 ? (
                                    <svg style={{marginLeft: "-1rem", marginTop: "-1rem", cursor: "pointer"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="12" cy="12" r="11.625" fill="#D9D9D9" stroke="url(#paint0_linear_415_4149)" strokeWidth="0.75"/>
                                      <circle cx="12" cy="12" r="7.99219" fill="url(#paint1_linear_415_4149)" stroke="#F2F4F7" strokeWidth="0.515625"/>
                                      <defs>
                                        <linearGradient id="paint0_linear_415_4149" x1="19.4883" y1="95.1634" x2="-5.93106" y2="93.5519" gradientUnits="userSpaceOnUse">
                                          <stop stopColor="#7928CA"/>
                                          <stop offset="1" stopColor="#FF0080"/>
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_415_4149" x1="17.1482" y1="69.1749" x2="-0.327605" y2="68.0669" gradientUnits="userSpaceOnUse">
                                          <stop stopColor="#7928CA"/>
                                          <stop offset="1" stopColor="#FF0080"/>
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                    ) : (
                                      <svg style={{marginLeft: "-1rem", marginTop: "-1rem", cursor: "pointer"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="11.5" fill="#FCFCFD" stroke="#98A2B3"/>
                                      </svg>
                                    )}
                                    <SoftBox sx={{marginTop: "-1.5rem", marginBottom: "3rem"}}>
                                      <svg style={{margin: "0 auto"}} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="url(#paint0_linear_415_4142)" fillOpacity="0.1"/>
                                        <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="url(#paint1_linear_415_4142)"/>
                                        <path d="M25.65 15.5859H14.332C13.953 15.5859 13.646 15.8929 13.646 16.2719V27.5899C13.646 27.9689 13.953 28.2759 14.3315 28.2759H25.65C26.0285 28.2759 26.336 27.9689 26.336 27.5899V16.2719C26.336 15.8929 26.0285 15.5859 25.65 15.5859Z" stroke="url(#paint2_linear_415_4142)" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M26.2699 25.422L27.3099 25.531C27.3994 25.5405 27.49 25.5322 27.5764 25.5067C27.6628 25.4811 27.7432 25.4387 27.8132 25.382C27.8832 25.3253 27.9413 25.2554 27.9843 25.1762C28.0272 25.097 28.0541 25.0101 28.0634 24.9205L29.2459 13.6645C29.2554 13.5749 29.2472 13.4843 29.2217 13.3979C29.1962 13.3115 29.1539 13.231 29.0973 13.161C29.0406 13.0909 28.9707 13.0327 28.8915 12.9898C28.8123 12.9468 28.7255 12.9199 28.6359 12.9105L17.3789 11.7275C17.2892 11.7179 17.1986 11.7262 17.1122 11.7517C17.0257 11.7772 16.9452 11.8195 16.8751 11.8763C16.8051 11.933 16.7469 12.003 16.704 12.0822C16.661 12.1614 16.6341 12.2484 16.6249 12.338L16.2874 15.55" stroke="url(#paint3_linear_415_4142)" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M16.5419 13.1951L11.3639 13.7401C10.9874 13.7801 10.7139 14.1171 10.7539 14.4941L11.9384 25.7496C11.9784 26.1266 12.3154 26.3996 12.6924 26.3601L13.5764 26.2671M16.2669 18.6206H23.7149M16.2669 20.8276H23.7149M16.2669 23.0351H23.7149M16.2669 25.2421H19.7149" stroke="url(#paint4_linear_415_4142)" strokeLinecap="round" strokeLinejoin="round"/>
                                        <defs>
                                          <linearGradient id="paint0_linear_415_4142" x1="32.4806" y1="158.606" x2="-9.8851" y2="155.92" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                          <linearGradient id="paint1_linear_415_4142" x1="32.4806" y1="158.606" x2="-9.8851" y2="155.92" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                          <linearGradient id="paint2_linear_415_4142" x1="23.9505" y1="65.9036" x2="10.5099" y2="65.0515" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                          <linearGradient id="paint3_linear_415_4142" x1="26.813" y1="66.4869" x2="13.0774" y2="65.6696" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                          <linearGradient id="paint4_linear_415_4142" x1="21.2777" y1="65.4112" x2="7.54433" y2="64.5541" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                      <SoftTypography variant="h2" 
                                        sx={{ 
                                          fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                          fontWeight: "600", 
                                          marginTop: screenWidth <= 1280 ? "1rem" : "2rem",
                                          color: "#000000",
                                        }}
                                      >
                                        Manual Submission
                                      </SoftTypography>
                                      <SoftBox sx={{padding: "0.5rem 2rem"}}>
                                        <SoftTypography variant="h2" 
                                          sx={{ 
                                            fontSize: screenWidth <= 1280 ? "12px" : "14px", 
                                            fontWeight: "500", 
                                            color: "#475467",
                                            lineHeight: "18px",
                                          }}
                                        >
                                          Let players send in their progress directly. Choose whether they’ll submit text  or upload images as proof of their results.
                                        </SoftTypography>
                                      </SoftBox>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                              </Grid>
                              <Grid item mini={6} pl={1}>
                                <SoftBox
                                  onClick={() => {
                                    setopenDSDialog(true);
                                    }} 
                                  sx={{
                                      background: "#FFFFFF",
                                      borderRadius: "4px",
                                      padding: screenWidth <= 1280 ? "1rem 0.5rem 1rem 0.5rem" : "2rem",
                                      textAlign: "center",
                                  }}
                                >
                                  <SoftBox>
                                    {newKpi?.isNew || newKpi?.isZapier || newKpi?.integrationId || metricData?.integrationId ? (
                                    <svg style={{marginLeft: "-1rem", marginTop: "-1rem", cursor: "pointer"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="12" cy="12" r="11.625" fill="#D9D9D9" stroke="url(#paint0_linear_415_4149)" strokeWidth="0.75"/>
                                      <circle cx="12" cy="12" r="7.99219" fill="url(#paint1_linear_415_4149)" stroke="#F2F4F7" strokeWidth="0.515625"/>
                                      <defs>
                                        <linearGradient id="paint0_linear_415_4149" x1="19.4883" y1="95.1634" x2="-5.93106" y2="93.5519" gradientUnits="userSpaceOnUse">
                                          <stop stopColor="#7928CA"/>
                                          <stop offset="1" stopColor="#FF0080"/>
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_415_4149" x1="17.1482" y1="69.1749" x2="-0.327605" y2="68.0669" gradientUnits="userSpaceOnUse">
                                          <stop stopColor="#7928CA"/>
                                          <stop offset="1" stopColor="#FF0080"/>
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                    ) : (
                                      <svg style={{marginLeft: "-1rem", marginTop: "-1rem", cursor: "pointer"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="11.5" fill="#FCFCFD" stroke="#98A2B3"/>
                                      </svg>
                                    )}
                                    <SoftBox sx={{marginTop: "-1.5rem", marginBottom: newKpi ? "0rem" : "3rem"}}>
                                      <svg style={{margin: "0 auto"}} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="url(#paint0_linear_415_4154)" fillOpacity="0.1"/>
                                        <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="url(#paint1_linear_415_4154)"/>
                                        <path d="M18.5501 26.1999L23.7251 19.9999H19.7251L20.4501 14.3249L15.8251 20.9999H19.3001L18.5501 26.1999ZM17.1541 28.8849L18.1541 21.9999H13.9041L21.3841 11.2119H21.8461L20.8661 18.9999H25.8661L17.6161 28.8849H17.1541Z" fill="url(#paint2_linear_415_4154)"/>
                                        <defs>
                                          <linearGradient id="paint0_linear_415_4154" x1="32.4806" y1="158.606" x2="-9.8851" y2="155.92" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                          <linearGradient id="paint1_linear_415_4154" x1="32.4806" y1="158.606" x2="-9.8851" y2="155.92" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                          <linearGradient id="paint2_linear_415_4154" x1="23.6174" y1="81.2879" x2="10.9204" y2="80.743" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#7928CA"/>
                                            <stop offset="1" stopColor="#FF0080"/>
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                      <SoftTypography variant="h2" 
                                        sx={{ 
                                          fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                          fontWeight: "600", 
                                          marginTop: screenWidth <= 1280 ? "1rem" : "2rem",
                                          color: "#000000",
                                        }}
                                      >
                                        Integrated Applications
                                      </SoftTypography>
                                      <SoftBox sx={{padding: "0.5rem 2rem"}}>
                                        <SoftTypography variant="h2" 
                                          sx={{ 
                                            fontSize: screenWidth <= 1280 ? "12px" : "14px", 
                                            fontWeight: "500", 
                                            color: "#475467",
                                            lineHeight: "18px",
                                          }}
                                        >
                                          Connect to apps your players already use. Their progress updates will sync automatically, keeping everything accurate.
                                        </SoftTypography>
                                        {newKpi && newKpi.type && (
                                          <div className="flex gap-2 items-center justify-content-center mt-5" style={{ marginBottom: '-1.25rem' }}>
                                            <SoftProfile
                                              src={newKpi.logo}
                                              name={newKpi.name}
                                              size="xs"
                                              borderRadius="sm"
                                              sx={{ background: "#FFF", padding: "2px" }}
                                            />
                                            <SoftTypography
                                              variant="body2"
                                              sx={{ 
                                                fontSize: screenWidth <= 1280 ? "12px" : "14px", 
                                                fontWeight: "500", 
                                                color: "#475467",
                                                lineHeight: "18px",
                                                textTransform: "capitalize"
                                              }}
                                            >
                                              {newKpi.type}
                                            </SoftTypography>
                                          </div>
                                        )}
                                      </SoftBox>
                                    </SoftBox>
                                  </SoftBox>
                                </SoftBox>
                              </Grid>
                            </Grid>
                          )}
                          {isStep === 2 && (
                            <Grid container>
                              <Grid item mini={12} mb={2} textAlign="center">
                                <SoftTypography variant="h2" 
                                  sx={{ 
                                      fontSize: screenWidth <= 1280 ? "14px" : "20px",
                                      fontWeight: 700,
                                      lineHeight: "26px",
                                      textAlign: "center",
                                      color: "#000000",
                                      }}>
                                  Metric Goal Setup</SoftTypography>
                                <SoftTypography variant="p" 
                                  sx={{ 
                                    fontSize: screenWidth <= 1280 ? "12px" : "14px", 
                                    fontWeight: "500",
                                    lineHeight: "18px",
                                    textAlign: "center",
                                    color: "#667085",
                                  }}>Where your metric pulls info from</SoftTypography>
                              </Grid>
                              <Grid item mini={12} p={2}>
                                <SoftBox> 
                                  <Grid item mini={12} sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem', marginBottom: "1rem" }}>
                                    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.0339 5.99008C14.8166 6.20526 14.5231 6.32595 14.2172 6.32595C13.9113 6.32595 13.6178 6.20526 13.4004 5.99008C13.2932 5.88406 13.208 5.75781 13.1499 5.61864C13.0918 5.47947 13.0619 5.33015 13.0619 5.17933C13.0619 5.02852 13.0918 4.8792 13.1499 4.74003C13.208 4.60086 13.2932 4.47461 13.4004 4.36858C13.6179 4.15296 13.9117 4.03197 14.2179 4.03197C14.5242 4.03197 14.818 4.15296 15.0354 4.36858C15.4854 4.81708 15.4854 5.54308 15.0354 5.99008M1.80545 12.7401C1.52471 12.4625 1.30184 12.1319 1.14974 11.7676C0.997628 11.4033 0.919307 11.0124 0.919307 10.6176C0.919307 10.2228 0.997628 9.83189 1.14974 9.46756C1.30184 9.10323 1.52471 8.77269 1.80545 8.49508L8.94095 1.40008C9.50564 0.839836 10.268 0.524118 11.0634 0.521084L15.9609 0.500084C16.3592 0.497105 16.7541 0.573172 17.1227 0.723882C17.4913 0.874591 17.8264 1.09695 18.1085 1.37807C18.3906 1.65919 18.6141 1.99349 18.7661 2.3616C18.9181 2.72972 18.9955 3.12433 18.9939 3.52258L18.9564 8.58208C18.9491 9.37124 18.6312 10.1257 18.0714 10.6821L11.0379 17.6721C10.4703 18.2359 9.70274 18.5523 8.9027 18.5523C8.10265 18.5523 7.33508 18.2359 6.76745 17.6721L1.80545 12.7401ZM2.87195 9.55558C2.73176 9.69449 2.62049 9.85979 2.54455 10.0419C2.46861 10.2241 2.42951 10.4195 2.42951 10.6168C2.42951 10.8142 2.46861 11.0096 2.54455 11.1917C2.62049 11.3739 2.73176 11.5392 2.87195 11.6781L7.83695 16.6131C8.42645 17.1981 9.38195 17.1981 9.97295 16.6131L17.0049 9.62008C17.2848 9.34191 17.4438 8.96466 17.4474 8.57008L17.4834 3.51058C17.484 3.3118 17.4453 3.11487 17.3694 2.93114C17.2935 2.74741 17.182 2.58053 17.0413 2.44011C16.9006 2.29969 16.7335 2.18851 16.5496 2.11299C16.3657 2.03747 16.1687 1.99909 15.9699 2.00008L11.0724 2.02108C10.6747 2.02117 10.2932 2.17926 10.0119 2.46058L2.87195 9.55558ZM0.995445 13.6251C0.793941 14.1644 0.751851 14.7502 0.874198 15.3127C0.996546 15.8753 1.27816 16.3907 1.68545 16.7976L4.63145 19.7436C5.1886 20.3008 5.85005 20.7428 6.57802 21.0443C7.306 21.3458 8.08624 21.5011 8.8742 21.5011C9.66215 21.5011 10.4424 21.3458 11.1704 21.0443C11.8983 20.7428 12.5598 20.3008 13.1169 19.7436L18.3399 14.5206C18.762 14.099 18.9994 13.5271 18.9999 12.9306V11.7606L13.1169 17.6436C13.0149 17.7476 12.9094 17.8461 12.8004 17.9391L12.0564 18.6831C11.6386 19.101 11.1425 19.4326 10.5964 19.6588C10.0504 19.885 9.46521 20.0014 8.8742 20.0014C8.28318 20.0014 7.69796 19.885 7.15194 19.6588C6.60593 19.4326 6.10982 19.101 5.69195 18.6831L4.94495 17.9346C4.83753 17.8413 4.73346 17.7443 4.63295 17.6436L1.68545 14.6976C1.38124 14.3937 1.14592 14.0279 0.995445 13.6251Z" fill="#667085"/> </svg>
                                    <SoftTypography variant="h2" sx={{ ...inputLabel }}>
                                      Name your Metric
                                    </SoftTypography>
                                  </Grid>
                                  {!dataMetric && (
                                  <SoftInput
                                    name="metricName"
                                    placeholder={metricData != null ? metricData.title : "Metric Name"}
                                    type="text"
                                    autoComplete="off"
                                    value={metricName || (newKpi && newKpi.type ? newKpi.type.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "")}
                                    sx={{
                                      ...inputFieldStyles,
                                      border: inputError && inputError.metricName && "1px solid #B50609!important",
                                    }}
                                    onChange={(e) => {
                                      setInputError({ ...inputError, metricName: false });
                                      setmetricName(e.target.value);
                                    }}
                                  />
                                  )}
                                  <SoftTypography 
                                  sx={{
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontStyle: "normal",
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    color: "#667085",
                                  }}>
                                    Give your metric a clear name so players know what they’re working toward.
                                  </SoftTypography>
                                  {ismetricType === "Anchor Metric" && (
                                    <Grid container sx={{ marginTop: screenWidth <= 1280 ? "0.5rem" : "1rem" }}>
                                        <Grid item mini={6} p={2} pl={0}>
                                          <SoftBox sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem' }}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginTop: "-0.15rem", marginBottom: "0.15rem"}}>
                                              <path d="M12.0001 4.49824C10.7718 4.49789 9.56228 4.79921 8.47773 5.3757C7.39318 5.95219 6.46682 6.78622 5.78002 7.80451C5.09323 8.8228 4.66704 9.99418 4.53889 11.2157C4.41074 12.4373 4.58456 13.6716 5.04507 14.8102C5.06975 14.8711 5.08221 14.9362 5.08173 15.0019C5.08125 15.0676 5.06783 15.1326 5.04225 15.193C5.01666 15.2535 4.97942 15.3084 4.93263 15.3545C4.88584 15.4006 4.83043 15.4371 4.76957 15.4617C4.7087 15.4864 4.64356 15.4989 4.57788 15.4984C4.5122 15.4979 4.44726 15.4845 4.38676 15.4589C4.32626 15.4333 4.2714 15.3961 4.22529 15.3493C4.17919 15.3025 4.14276 15.2471 4.11807 15.1862C3.38323 13.3688 3.29917 11.3533 3.88013 9.48101C4.46108 7.60873 5.67134 5.9948 7.3059 4.9126C8.94046 3.8304 10.8988 3.34645 12.8493 3.54273C14.7998 3.739 16.6225 4.60343 18.0087 5.98961C19.3949 7.37578 20.2593 9.19848 20.4556 11.149C20.6519 13.0995 20.1679 15.0578 19.0857 16.6924C18.0035 18.327 16.3896 19.5372 14.5173 20.1182C12.645 20.6991 10.6295 20.6151 8.81207 19.8802C8.69002 19.8299 8.59283 19.7333 8.54171 19.6116C8.49059 19.4899 8.48969 19.3529 8.5392 19.2305C8.58871 19.1081 8.68461 19.0103 8.80598 18.9583C8.92736 18.9064 9.06435 18.9046 9.18707 18.9532C10.2125 19.3671 11.3168 19.549 12.4209 19.4861C13.5249 19.4231 14.6014 19.1168 15.5731 18.589C16.5449 18.0613 17.388 17.3252 18.0419 16.4334C18.6958 15.5417 19.1445 14.5164 19.3557 13.4309C19.567 12.3454 19.5356 11.2267 19.2637 10.1548C18.9919 9.08287 18.4865 8.08433 17.7835 7.23068C17.0806 6.37703 16.1975 5.68938 15.1977 5.21699C14.1978 4.7446 13.1059 4.49916 12.0001 4.49824Z" fill="#667085"/>
                                              <path d="M6.49988 11.9981C6.49988 13.3371 6.97788 14.5641 7.77288 15.5181L7.29288 15.9981H5.76988C5.37219 15.9984 4.99091 16.1567 4.70988 16.4381L3.07188 18.0751C2.96712 18.18 2.8958 18.3135 2.86691 18.4589C2.83803 18.6043 2.85288 18.755 2.90959 18.892C2.9663 19.029 3.06233 19.146 3.18555 19.2285C3.30876 19.3109 3.45364 19.3549 3.60188 19.3551H4.64188V20.3951C4.64201 20.5433 4.68607 20.6882 4.76849 20.8114C4.85091 20.9346 4.96799 21.0306 5.10496 21.0874C5.24192 21.1441 5.39262 21.1589 5.53802 21.13C5.68341 21.1012 5.81699 21.0298 5.92188 20.9251L7.55888 19.2871C7.84039 19.0064 7.999 18.6256 7.99988 18.2281V16.7061L8.47988 16.2261C9.44106 17.0267 10.6464 17.4757 11.8971 17.499C13.1478 17.5224 14.3691 17.1187 15.3596 16.3546C16.35 15.5905 17.0503 14.5116 17.345 13.2958C17.6398 12.0801 17.5113 10.8003 16.9808 9.66743C16.4502 8.53458 15.5494 7.61642 14.4268 7.06443C13.3043 6.51244 12.0271 6.35961 10.806 6.63115C9.58491 6.90268 8.49285 7.58236 7.71001 8.55805C6.92717 9.53374 6.50032 10.7471 6.49988 11.9981ZM11.9999 7.49807C12.7186 7.49831 13.4269 7.67072 14.0654 8.00087C14.7038 8.33102 15.2539 8.8093 15.6696 9.39569C16.0853 9.98208 16.3544 10.6595 16.4545 11.3713C16.5546 12.083 16.4828 12.8084 16.245 13.4867C16.0072 14.165 15.6105 14.7765 15.0878 15.27C14.5652 15.7634 13.932 16.1245 13.2412 16.323C12.5504 16.5216 11.8221 16.5517 11.1172 16.411C10.4124 16.2702 9.75148 15.9627 9.18988 15.5141L10.9829 13.7211C11.4022 13.9683 11.8973 14.0541 12.3754 13.9625C12.8535 13.8708 13.2817 13.6079 13.5798 13.223C13.8779 12.8382 14.0254 12.3578 13.9947 11.872C13.964 11.3862 13.7571 10.9282 13.4129 10.584C13.0687 10.2398 12.6108 10.033 12.1249 10.0022C11.6391 9.97151 11.1588 10.119 10.7739 10.4171C10.3891 10.7152 10.1262 11.1435 10.0345 11.6216C9.94281 12.0996 10.0286 12.5947 10.2759 13.0141L8.48388 14.8071C7.95488 14.145 7.62359 13.347 7.52813 12.505C7.43267 11.6629 7.57693 10.811 7.9443 10.0473C8.31167 9.28363 8.88722 8.63921 9.6047 8.18821C10.3222 7.73722 11.1524 7.498 11.9999 7.49807ZM5.41688 17.1441C5.4634 17.0977 5.51861 17.0609 5.57935 17.0358C5.64009 17.0108 5.70517 16.998 5.77088 16.9981H6.99988V18.2271C6.99959 18.3596 6.94672 18.4865 6.85288 18.5801L5.64288 19.7901V18.8551C5.64288 18.7225 5.5902 18.5953 5.49643 18.5015C5.40267 18.4077 5.27549 18.3551 5.14288 18.3551H4.20688L5.41688 17.1441Z" fill="#667085"/>
                                            </svg>
                                            <SoftTypography variant="h2" sx={{ ...inputLabel }}>
                                              Set Your Anchor (Benchmark)
                                            </SoftTypography>
                                          </SoftBox>
                                          <Grid container 
                                            style={{
                                              background: "#FFFFFF",
                                              border: inputError && inputError.anchorPoint ? "1px solid #B50609!important" : "1px solid rgba(0, 0, 0, 0.15)",
                                              borderRadius: "4px",
                                            }}
                                          >
                                            <Grid item mini={10}>
                                              <SoftInput
                                                name="anchorPoint"
                                                placeholder="Enter Desired anchor point"
                                                fullWidth
                                                defaultValue={anchorPoint}
                                                sx={{
                                                    padding: "12px 20px",
                                                    background: "#FFFFFF",
                                                    border: "none !important",
                                                    borderRadius: "4px",
                                                    "&.Mui-focused": {
                                                      border: "none !important",
                                                      boxShadow: "none !important",
                                                    },
                                                    "& input": {
                                                      fontFamily: "DM Sans",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      lineHeight: "14px",
                                                      color: "#000000",
                                                    },
                                                }}
                                                onChange={(e) => {
                                                  setInputError({ ...inputError, anchorPoint: false });
                                                  setAnchorPoint(e.target.value);
                                                }}
                                              />
                                            </Grid>
                                            <Grid item mini={2} style={{paddingTop: "3px", paddingRight: "3px"}}>
                                              <SoftSelect
                                                options={anchorPointTypes}
                                                onChange={(option) => {
                                                  setValueType(option.value);
                                                }}
                                                defaultValue={getDefaultValue()}
                                                styles={{
                                                    control: {
                                                      background: "#F2F4F7 !important",
                                                      borderRadius: "2px !important",
                                                      fontFamily: 'DM Sans',
                                                      fontSize: "16px !important",
                                                      border: "none !important"
                                                    },
                                                    placeholder:{
                                                      fontSize: "16px !important",
                                                      color: "#3D3D3F !important",
                                                    },
                                                    singleValue:{
                                                      fontSize: "16px !important",
                                                      color: "#3D3D3F !important",
                                                    },
                                                    input: {
                                                      fontSize: "16px !important",
                                                      color: "#3D3D3F !important",
                                                    }
                                                  }}
                                              />
                                            </Grid>
                                          </Grid>
                                          <SoftTypography 
                                          sx={{
                                            fontFamily: "'DM Sans', sans-serif",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            lineHeight: "16px",
                                            color: "#667085",
                                            marginTop: "0.25rem"
                                          }}>
                                            This is the benchmark players will try to hit
                                          </SoftTypography>
                                        </Grid>
                                        <Grid item mini={6} p={2} pr={0}>
                                          <SoftBox sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem', marginBottom: "0.5rem" }}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M24 12H10.4297C10.3359 12.4375 10.1758 12.8398 9.94922 13.207C9.72266 13.5742 9.44922 13.8906 9.12891 14.1562C8.80859 14.4219 8.44141 14.6289 8.02734 14.7773C7.61328 14.9258 7.1875 15 6.75 15C6.30469 15 5.87891 14.9258 5.47266 14.7773C5.06641 14.6289 4.70313 14.4219 4.38281 14.1562C4.0625 13.8906 3.78516 13.5742 3.55078 13.207C3.31641 12.8398 3.15625 12.4375 3.07031 12H0V10.5H3.07031C3.16406 10.0625 3.32422 9.66016 3.55078 9.29297C3.77734 8.92578 4.05078 8.60937 4.37109 8.34375C4.69141 8.07813 5.05859 7.87109 5.47266 7.72266C5.88672 7.57422 6.3125 7.5 6.75 7.5C7.19531 7.5 7.62109 7.57422 8.02734 7.72266C8.43359 7.87109 8.79687 8.07813 9.11719 8.34375C9.4375 8.60937 9.71484 8.92578 9.94922 9.29297C10.1836 9.66016 10.3437 10.0625 10.4297 10.5H24V12ZM6.75 13.5C7.0625 13.5 7.35547 13.4414 7.62891 13.3242C7.90234 13.207 8.14062 13.0469 8.34375 12.8438C8.54688 12.6406 8.70703 12.4023 8.82422 12.1289C8.94141 11.8555 9 11.5625 9 11.25C9 10.9375 8.94141 10.6445 8.82422 10.3711C8.70703 10.0977 8.54688 9.85938 8.34375 9.65625C8.14062 9.45312 7.90234 9.29297 7.62891 9.17578C7.35547 9.05859 7.0625 9 6.75 9C6.4375 9 6.14453 9.05859 5.87109 9.17578C5.59766 9.29297 5.35938 9.45312 5.15625 9.65625C4.95312 9.85938 4.79297 10.0977 4.67578 10.3711C4.55859 10.6445 4.5 10.9375 4.5 11.25C4.5 11.5625 4.55859 11.8555 4.67578 12.1289C4.79297 12.4023 4.95312 12.6406 5.15625 12.8438C5.35938 13.0469 5.59766 13.207 5.87109 13.3242C6.14453 13.4414 6.4375 13.5 6.75 13.5Z" fill="#667085"/>
                                            </svg>
                                            <SoftTypography variant="h2" sx={{ ...inputLabel }}>
                                            Set Unit Value
                                            </SoftTypography>
                                          </SoftBox>
                                          <SoftInput
                                            name="unit"
                                            type="number"
                                            value={unit}
                                            defaultValue={unit}
                                            onChange={(e) => setUnit(Number(e.target.value))}
                                            autoComplete="off"
                                            sx={{
                                              ...inputFieldStyles,
                                              '& input[type=number]': {
                                                MozAppearance: 'textfield',
                                              },
                                              '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                              },
                                            }}
                                          />
                                          <SoftTypography 
                                          sx={{
                                            fontFamily: "'DM Sans', sans-serif",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            lineHeight: "16px",
                                            color: "#667085",
                                            marginTop: "0.25rem"
                                          }}>
                                            The unit of the scale
                                          </SoftTypography>
                                        </Grid>
                                    </Grid>
                                  )}
                                  {ismetricType === "Anchor Metric" && (
                                    <Grid container sx={{ marginTop: screenWidth <= 1280 ? "0.5rem" : "1rem" }}>
                                      <Grid item mini={12} sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem' }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginTop: "-0.15rem", marginBottom: "0.15rem"}}>
                                          <path d="M12.0001 4.49824C10.7718 4.49789 9.56228 4.79921 8.47773 5.3757C7.39318 5.95219 6.46682 6.78622 5.78002 7.80451C5.09323 8.8228 4.66704 9.99418 4.53889 11.2157C4.41074 12.4373 4.58456 13.6716 5.04507 14.8102C5.06975 14.8711 5.08221 14.9362 5.08173 15.0019C5.08125 15.0676 5.06783 15.1326 5.04225 15.193C5.01666 15.2535 4.97942 15.3084 4.93263 15.3545C4.88584 15.4006 4.83043 15.4371 4.76957 15.4617C4.7087 15.4864 4.64356 15.4989 4.57788 15.4984C4.5122 15.4979 4.44726 15.4845 4.38676 15.4589C4.32626 15.4333 4.2714 15.3961 4.22529 15.3493C4.17919 15.3025 4.14276 15.2471 4.11807 15.1862C3.38323 13.3688 3.29917 11.3533 3.88013 9.48101C4.46108 7.60873 5.67134 5.9948 7.3059 4.9126C8.94046 3.8304 10.8988 3.34645 12.8493 3.54273C14.7998 3.739 16.6225 4.60343 18.0087 5.98961C19.3949 7.37578 20.2593 9.19848 20.4556 11.149C20.6519 13.0995 20.1679 15.0578 19.0857 16.6924C18.0035 18.327 16.3896 19.5372 14.5173 20.1182C12.645 20.6991 10.6295 20.6151 8.81207 19.8802C8.69002 19.8299 8.59283 19.7333 8.54171 19.6116C8.49059 19.4899 8.48969 19.3529 8.5392 19.2305C8.58871 19.1081 8.68461 19.0103 8.80598 18.9583C8.92736 18.9064 9.06435 18.9046 9.18707 18.9532C10.2125 19.3671 11.3168 19.549 12.4209 19.4861C13.5249 19.4231 14.6014 19.1168 15.5731 18.589C16.5449 18.0613 17.388 17.3252 18.0419 16.4334C18.6958 15.5417 19.1445 14.5164 19.3557 13.4309C19.567 12.3454 19.5356 11.2267 19.2637 10.1548C18.9919 9.08287 18.4865 8.08433 17.7835 7.23068C17.0806 6.37703 16.1975 5.68938 15.1977 5.21699C14.1978 4.7446 13.1059 4.49916 12.0001 4.49824Z" fill="#667085"/>
                                          <path d="M6.49988 11.9981C6.49988 13.3371 6.97788 14.5641 7.77288 15.5181L7.29288 15.9981H5.76988C5.37219 15.9984 4.99091 16.1567 4.70988 16.4381L3.07188 18.0751C2.96712 18.18 2.8958 18.3135 2.86691 18.4589C2.83803 18.6043 2.85288 18.755 2.90959 18.892C2.9663 19.029 3.06233 19.146 3.18555 19.2285C3.30876 19.3109 3.45364 19.3549 3.60188 19.3551H4.64188V20.3951C4.64201 20.5433 4.68607 20.6882 4.76849 20.8114C4.85091 20.9346 4.96799 21.0306 5.10496 21.0874C5.24192 21.1441 5.39262 21.1589 5.53802 21.13C5.68341 21.1012 5.81699 21.0298 5.92188 20.9251L7.55888 19.2871C7.84039 19.0064 7.999 18.6256 7.99988 18.2281V16.7061L8.47988 16.2261C9.44106 17.0267 10.6464 17.4757 11.8971 17.499C13.1478 17.5224 14.3691 17.1187 15.3596 16.3546C16.35 15.5905 17.0503 14.5116 17.345 13.2958C17.6398 12.0801 17.5113 10.8003 16.9808 9.66743C16.4502 8.53458 15.5494 7.61642 14.4268 7.06443C13.3043 6.51244 12.0271 6.35961 10.806 6.63115C9.58491 6.90268 8.49285 7.58236 7.71001 8.55805C6.92717 9.53374 6.50032 10.7471 6.49988 11.9981ZM11.9999 7.49807C12.7186 7.49831 13.4269 7.67072 14.0654 8.00087C14.7038 8.33102 15.2539 8.8093 15.6696 9.39569C16.0853 9.98208 16.3544 10.6595 16.4545 11.3713C16.5546 12.083 16.4828 12.8084 16.245 13.4867C16.0072 14.165 15.6105 14.7765 15.0878 15.27C14.5652 15.7634 13.932 16.1245 13.2412 16.323C12.5504 16.5216 11.8221 16.5517 11.1172 16.411C10.4124 16.2702 9.75148 15.9627 9.18988 15.5141L10.9829 13.7211C11.4022 13.9683 11.8973 14.0541 12.3754 13.9625C12.8535 13.8708 13.2817 13.6079 13.5798 13.223C13.8779 12.8382 14.0254 12.3578 13.9947 11.872C13.964 11.3862 13.7571 10.9282 13.4129 10.584C13.0687 10.2398 12.6108 10.033 12.1249 10.0022C11.6391 9.97151 11.1588 10.119 10.7739 10.4171C10.3891 10.7152 10.1262 11.1435 10.0345 11.6216C9.94281 12.0996 10.0286 12.5947 10.2759 13.0141L8.48388 14.8071C7.95488 14.145 7.62359 13.347 7.52813 12.505C7.43267 11.6629 7.57693 10.811 7.9443 10.0473C8.31167 9.28363 8.88722 8.63921 9.6047 8.18821C10.3222 7.73722 11.1524 7.498 11.9999 7.49807ZM5.41688 17.1441C5.4634 17.0977 5.51861 17.0609 5.57935 17.0358C5.64009 17.0108 5.70517 16.998 5.77088 16.9981H6.99988V18.2271C6.99959 18.3596 6.94672 18.4865 6.85288 18.5801L5.64288 19.7901V18.8551C5.64288 18.7225 5.5902 18.5953 5.49643 18.5015C5.40267 18.4077 5.27549 18.3551 5.14288 18.3551H4.20688L5.41688 17.1441Z" fill="#667085"/>
                                        </svg>
                                        <SoftTypography variant="h2" sx={{ ...inputLabel }}> Define how performance translates to points</SoftTypography>
                                      </Grid>
                                    </Grid>
                                  )}
                                  {ismetricType === "Anchor Metric" && (
                                    <Grid container sx={{ background: "#FFFFFF", borderRadius: "7.26277px", border: "1.5px solid #EAECF0", padding: screenWidth <= 1280 ? "0.50rem" : "1rem 1.5rem" }}>
                                      <Grid item mini={12}>
                                        <SoftTypography variant="h2"
                                        sx={{
                                          fontFamily: "'DM Sans', sans-serif",
                                          fontStyle: "normal",
                                          fontWeight: 600,
                                          fontSize: "16px",
                                          lineHeight: "21px",
                                          color: "#667085",
                                          marginBottom: "0.5rem"
                                        }}>
                                        Benchmark point
                                        </SoftTypography>
                                        <SoftInput
                                          name="benchmarkPoint"
                                          type="number"
                                          autoComplete="off"
                                          value={benchmarkPoint}
                                          onChange={(e) => {
                                            setBenchmarkPoint(e.target.value);
                                            setInputError({ ...inputError, benchmarkPoint: false });
                                          }}
                                          sx={{
                                            ...inputFieldStyles,
                                            background: "#F9FAFB !important",
                                            paddingTop: "0.5rem !important",
                                            paddingBottom: "0.5rem !important",
                                            marginTop: "0.5rem !important",
                                            border: inputError && inputError.benchmarkPoint && "1px solid #B50609!important",
                                            '& input[type=number]': {
                                              MozAppearance: 'textfield',
                                            },
                                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                              WebkitAppearance: 'none',
                                              margin: 0,
                                            },
                                          }}
                                        />
                                      </Grid> 
                                      <Grid item mini={12}>
                                          <SoftTypography 
                                          sx={{
                                            textAlign: "center",
                                            fontFamily: "'DM Sans', sans-serif",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            lineHeight: "16px",
                                            background: "linear-gradient(273.63deg, #7928CA 0%, #FF0080 100%)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                            backgroundClip: "text",
                                            color: "transparent",
                                            marginTop: "1.5rem",
                                            marginBottom: ".5rem"
                                          }}>
                                            How many points is deducted or added to player
                                          </SoftTypography>
                                      </Grid>
                                      <Grid item mini={12}>
                                        <Grid container>
                                            <Grid item mini={6} p={2} pl={0}>
                                                <svg width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect width="15" height="4" rx="2" fill="#F72819"/>
                                                </svg>
                                                <SoftTypography variant="h2"
                                                sx={{
                                                  fontFamily: "'DM Sans', sans-serif",
                                                  fontStyle: "normal",
                                                  fontWeight: 600,
                                                  fontSize: "16px",
                                                  lineHeight: "21px",
                                                  color: "#667085",
                                                  marginBottom: "0.5rem"
                                                }}>
                                                  Point lost per unit below the Goal
                                                </SoftTypography>
                                                <SoftInput
                                                  name="belowBenchmark"
                                                  type="number"
                                                  fullWidth
                                                  value={belowBenchmark}
                                                  onChange={(e) => {
                                                    setBelowBenchmark(e.target.value);
                                                    setInputError({ ...inputError, belowBenchmark: false });
                                                  }}
                                                  sx={{
                                                    ...inputFieldStyles,
                                                    background: "#F9FAFB !important",
                                                    paddingTop: "0.5rem !important",
                                                    paddingBottom: "0.5rem !important",
                                                    marginTop: "0.5rem !important",
                                                    border: inputError && inputError.belowBenchmark && "1px solid #B50609!important",
                                                    '& input[type=number]': {
                                                      MozAppearance: 'textfield',
                                                    },
                                                    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                      WebkitAppearance: 'none',
                                                      margin: 0,
                                                    },
                                                  }}
                                                />
                                            </Grid>
                                            <Grid item mini={6} p={2} pr={0}>
                                              <svg width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="15" height="4" rx="2" fill="#299E47"/>
                                              </svg>
                                              <SoftTypography variant="h2"
                                              sx={{
                                                fontFamily: "'DM Sans', sans-serif",
                                                fontStyle: "normal",
                                                fontWeight: 600,
                                                fontSize: "16px",
                                                lineHeight: "21px",
                                                color: "#667085",
                                                marginBottom: "0.5rem"
                                              }}>
                                                Point gains per unit Above the Goal
                                              </SoftTypography>
                                              <SoftInput
                                                name="aboveBenchmark"
                                                type="number"
                                                fullWidth
                                                value={aboveBenchmark}
                                                onChange={(e) => {
                                                  setAboveBenchmark(e.target.value);
                                                  setOzLoader(true);
                                                }}
                                                sx={{
                                                  ...inputFieldStyles,
                                                  background: "#F9FAFB !important",
                                                  paddingTop: "0.5rem !important",
                                                  paddingBottom: "0.5rem !important",
                                                  marginTop: "0.5rem !important",
                                                  border: inputError && inputError.aboveBenchmark && "1px solid #B50609!important",
                                                  '& input[type=number]': {
                                                    MozAppearance: 'textfield',
                                                  },
                                                  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}
                                  {ismetricType !== "Anchor Metric" && (
                                    <Grid container sx={{ marginTop: "1.5rem" }}>
                                      <Grid item mini={12} sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem' }}>
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginTop: "-0.25rem"}}>
                                          <path d="M13.0001 4.87488C11.6695 4.87451 10.3591 5.20093 9.18419 5.82546C8.00926 6.45 7.0057 7.35353 6.26167 8.45668C5.51765 9.55982 5.05594 10.8288 4.91711 12.1522C4.77828 13.4755 4.96658 14.8127 5.46547 16.0462C5.49221 16.1122 5.50571 16.1827 5.50519 16.2539C5.50466 16.325 5.49013 16.3954 5.46241 16.4609C5.4347 16.5265 5.39435 16.5859 5.34366 16.6358C5.29298 16.6858 5.23295 16.7253 5.16701 16.752C5.10107 16.7788 5.03051 16.7923 4.95935 16.7917C4.8882 16.7912 4.81784 16.7767 4.7523 16.749C4.68676 16.7212 4.62732 16.6809 4.57738 16.6302C4.52744 16.5795 4.48796 16.5195 4.46122 16.4536C3.66515 14.4847 3.57408 12.3012 4.20345 10.2729C4.83282 8.24458 6.14393 6.49616 7.9147 5.32377C9.68548 4.15139 11.8071 3.62711 13.9201 3.83974C16.0331 4.05237 18.0077 4.98884 19.5094 6.49053C21.0111 7.99222 21.9476 9.96681 22.1602 12.0798C22.3728 14.1929 21.8485 16.3145 20.6762 18.0852C19.5038 19.856 17.7554 21.1671 15.7271 21.7965C13.6987 22.4259 11.5152 22.3348 9.54639 21.5387C9.41417 21.4842 9.30888 21.3796 9.2535 21.2477C9.19812 21.1158 9.19714 20.9674 9.25078 20.8348C9.30441 20.7023 9.40831 20.5963 9.5398 20.54C9.67128 20.4837 9.81969 20.4817 9.95264 20.5345C11.0636 20.9828 12.2599 21.1799 13.4559 21.1117C14.652 21.0435 15.8181 20.7116 16.8709 20.1399C17.9236 19.5682 18.8369 18.7707 19.5454 17.8047C20.2538 16.8386 20.7398 15.7278 20.9687 14.5519C21.1975 13.376 21.1635 12.164 20.869 11.0028C20.5746 9.84156 20.027 8.75982 19.2655 7.83503C18.5039 6.91024 17.5473 6.16529 16.4641 5.65353C15.381 5.14178 14.198 4.87588 13.0001 4.87488Z" fill="#667085"/>
                                          <path d="M7.04162 12.9999C7.04162 14.4505 7.55945 15.7798 8.4207 16.8133L7.9007 17.3333H6.25078C5.81995 17.3337 5.40691 17.5051 5.10245 17.8099L3.32795 19.5834C3.21447 19.697 3.1372 19.8417 3.10591 19.9992C3.07461 20.1567 3.0907 20.32 3.15214 20.4684C3.21358 20.6167 3.31761 20.7436 3.45109 20.8329C3.58457 20.9222 3.74152 20.9699 3.90212 20.97H5.02878V22.0967C5.02893 22.2573 5.07665 22.4142 5.16594 22.5477C5.25523 22.6812 5.38207 22.7852 5.53045 22.8467C5.67883 22.9081 5.84208 22.9242 5.9996 22.8929C6.15711 22.8616 6.30182 22.7843 6.41545 22.6709L8.18887 20.8964C8.49383 20.5923 8.66566 20.1797 8.66662 19.7491V18.1003L9.18662 17.5803C10.2279 18.4476 11.5337 18.934 12.8886 18.9593C14.2436 18.9847 15.5667 18.5473 16.6396 17.7195C17.7126 16.8917 18.4713 15.7229 18.7905 14.4059C19.1098 13.0889 18.9706 11.7023 18.3959 10.4751C17.8212 9.24783 16.8452 8.25315 15.6291 7.65517C14.4131 7.05718 13.0294 6.89161 11.7066 7.18578C10.3837 7.47994 9.20067 8.21626 8.3526 9.27326C7.50452 10.3303 7.0421 11.6448 7.04162 12.9999ZM13 8.12494C13.7786 8.1252 14.5459 8.31198 15.2376 8.66964C15.9292 9.0273 16.5252 9.54545 16.9755 10.1807C17.4258 10.816 17.7174 11.5498 17.8258 12.3209C17.9343 13.092 17.8565 13.8778 17.5989 14.6126C17.3413 15.3475 16.9114 16.0099 16.3452 16.5445C15.7791 17.0791 15.0931 17.4703 14.3447 17.6853C13.5963 17.9004 12.8073 17.933 12.0437 17.7806C11.2801 17.6281 10.5642 17.2949 9.95578 16.8089L11.8982 14.8665C12.3525 15.1344 12.8888 15.2274 13.4068 15.128C13.9247 15.0287 14.3886 14.7439 14.7115 14.327C15.0345 13.9101 15.1943 13.3897 15.161 12.8634C15.1277 12.3371 14.9036 11.841 14.5307 11.4681C14.1578 11.0952 13.6617 10.8711 13.1354 10.8378C12.6091 10.8045 12.0887 10.9643 11.6718 11.2873C11.2549 11.6102 10.9701 12.0741 10.8708 12.592C10.7715 13.11 10.8644 13.6463 11.1323 14.1006L9.19095 16.043C8.61787 15.3258 8.25897 14.4613 8.15556 13.5491C8.05214 12.6368 8.20842 11.714 8.60641 10.8866C9.00439 10.0593 9.6279 9.36118 10.4052 8.8726C11.1824 8.38403 12.0819 8.12486 13 8.12494ZM5.86837 18.5748C5.91876 18.5245 5.97857 18.4847 6.04438 18.4575C6.11018 18.4304 6.18069 18.4165 6.25187 18.4166H7.58328V19.748C7.58297 19.8916 7.52569 20.0291 7.42403 20.1304L6.1132 21.4413V20.4284C6.1132 20.2847 6.05613 20.1469 5.95455 20.0453C5.85297 19.9438 5.71519 19.8867 5.57153 19.8867H4.55753L5.86837 18.5748Z" fill="#667085"/>
                                        </svg>
                                        <SoftTypography variant="h2" sx={{ ...inputLabel }}> Set Daily Target</SoftTypography>
                                      </Grid>
                                      <Grid item mini={12} sx={{marginTop: "1rem"}}>
                                        <SoftInput
                                          name="dailyTarget"
                                          type="number"
                                          value={targetValue}
                                          onChange={(e) => {
                                            setValue(e.target.value);
                                            setInputError({ ...inputError, targetValue: false });
                                          }}
                                          autoComplete="off"
                                          sx={{
                                            ...inputFieldStyles,
                                            border: inputError && inputError.targetValue && "1px solid #B50609!important",
                                            '& input[type=number]': {
                                              MozAppearance: 'textfield',
                                            },
                                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                              WebkitAppearance: 'none',
                                              margin: 0,
                                            },
                                          }}
                                        />
                                        <SoftTypography 
                                        sx={{
                                          fontFamily: "'DM Sans', sans-serif",
                                          fontStyle: "normal",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          lineHeight: "16px",
                                          color: "#667085",
                                        }}>
                                          Decide the daily goal for this metric. This is the benchmark players will try to hit.
                                        </SoftTypography>
                                      </Grid>
                                    </Grid>
                                  )}
                                  {ismetricType !== "Anchor Metric" && (
                                    <Grid container sx={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
                                      <Grid item mini={12} sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem' }}>
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.35189 22.286V21.0003H11.3568V16.1738C10.2571 16.0864 9.24573 15.6377 8.32259 14.8277C7.39775 14.0177 6.83333 13.0705 6.62933 11.9863C5.26992 11.826 4.11065 11.2684 3.15152 10.3136C2.19239 9.35874 1.71326 8.20676 1.71411 6.85763V4.28624H6.41205V1.71484H17.5873V4.28624H22.2853V6.85763C22.2853 8.2059 21.8061 9.35788 20.8479 10.3136C19.8896 11.2693 18.7303 11.8264 17.37 11.985C17.166 13.0701 16.6021 14.0177 15.6781 14.8277C14.7541 15.6377 13.7422 16.0864 12.6425 16.1738V21.0003H16.6488V22.286H7.35189ZM6.41205 10.6067V5.57193H2.99981V6.85763C2.99981 7.83647 3.32638 8.67775 3.97951 9.38145C4.63264 10.0852 5.44349 10.4936 6.41205 10.6067ZM12.0048 14.9177C13.1877 14.9177 14.1914 14.5041 15.0159 13.677C15.8405 12.8507 16.2528 11.8466 16.2528 10.6646V3.00054H7.7466V10.6659C7.7466 11.847 8.1606 12.8511 8.98859 13.6783C9.81657 14.5045 10.822 14.9177 12.0048 14.9177ZM17.5873 10.6067C18.5567 10.4927 19.3676 10.0843 20.0199 9.38145C20.6721 8.67861 20.9987 7.83733 20.9996 6.85763V5.57193H17.5873V10.6067Z" fill="#475467"/>
                                      </svg>
                                        <SoftTypography variant="h2" sx={{ ...inputLabel }}> Define how performance translates to points</SoftTypography>
                                      </Grid>
                                    </Grid>
                                  )}
                                  {ismetricType !== "Anchor Metric" && (
                                    <SoftBox container sx={{ background: "#FFFFFF", borderRadius: "7.26277px", border: "1.5px solid #EAECF0", padding: screenWidth <= 1280 ? "0.50rem" : "1rem 1.5rem" }}>
                                        <SoftBox  
                                          display="flex"
                                          gap="1rem"
                                          justi="between"
                                          alignItems="center"
                                          sx={{}}
                                        >
                                          <SoftBox>
                                            <svg width="6" height="95" viewBox="0 0 6 95" fill="none" style={{marginTop: "0.5rem"}} xmlns="http://www.w3.org/2000/svg">
                                              <path d="M0.000325521 2.66675C0.000325521 4.13951 1.19423 5.33341 2.66699 5.33341C4.13975 5.33341 5.33366 4.13951 5.33366 2.66675C5.33366 1.19399 4.13975 8.13802e-05 2.66699 8.13802e-05C1.19423 8.13802e-05 0.000325521 1.19399 0.000325521 2.66675ZM0.000325521 91.6892C0.000325521 93.162 1.19423 94.3559 2.66699 94.3559C4.13975 94.3559 5.33366 93.162 5.33366 91.6892C5.33366 90.2165 4.13975 89.0225 2.66699 89.0225C1.19423 89.0225 0.000325521 90.2165 0.000325521 91.6892ZM2.66699 2.66675H2.16699L2.16699 91.6892H2.66699H3.16699L3.16699 2.66675H2.66699Z" fill="#667085"/>
                                            </svg>
                                          </SoftBox>
                                          <SoftBox>
                                            <SoftBox display="flex" flexDirection="row" alignItems="center" gap="1rem">
                                              <SoftTypography 
                                              variant="h2" 
                                              sx={{ 
                                                fontFamily: 'DM Sans',
                                                fontStyle: 'normal',
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                lineHeight: '21px',
                                                color: '#667085',
                                              }}
                                              >
                                                If a Player Gets
                                              </SoftTypography>
                                              <SoftInput
                                                name="pointValue"
                                                type="number"
                                                value={pValue}
                                                onChange={(e) => {
                                                  setPValue(e.target.value);
                                                  setInputError({ ...inputError, pValue: false });
                                                }}
                                                autoComplete="off"
                                                sx={{
                                                  ...inputFieldStyles,
                                                  background: "#F9FAFB !important",
                                                  paddingTop: "0.5rem !important",
                                                  paddingBottom: "0.5rem !important",
                                                  maxWidth: "155px !important",
                                                  marginTop: "0.5rem !important",
                                                  border: inputError && inputError.pValue && "1px solid #B50609!important",
                                                  '& input[type=number]': {
                                                    MozAppearance: 'textfield',
                                                  },
                                                  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                                }}
                                              />
                                              <Button
                                                sx={{
                                                  background: "#FFFFFF",
                                                  borderRadius: "4px",
                                                  border: "1px solid #D0D5DD",
                                                  minWidth: "90px",
                                                  fontFamily: 'DM Sans',
                                                  fontStyle: 'normal',
                                                  fontWeight: 500,
                                                  fontSize: '14px',
                                                  lineHeight: '10px !important',
                                                  color: '#000000',
                                                  padding: !metricName ? "0.75rem 0.5rem !important" : "0.35rem 0.5rem !important",
                                                  boxShadow: "none !important",
                                                  textTransform: "capitalize"
                                                }}
                                              >
                                                {metricName}
                                              </Button>
                                            </SoftBox>
                                            <SoftBox display="flex" flexDirection="row" alignItems="center" gap="1rem" sx={{marginTop: "2rem"}}>
                                              <SoftTypography 
                                              variant="h2" 
                                              sx={{ 
                                                fontFamily: 'DM Sans',
                                                fontStyle: 'normal',
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                lineHeight: '21px',
                                                color: '#667085',
                                              }}
                                              >
                                              Then Players Earn 
                                              </SoftTypography>
                                              <SoftInput
                                                name="pointScale"
                                                type="number"
                                                value={psValue}
                                                onChange={(e) => {
                                                  setPsValue(e.target.value);
                                                  setOzLoader(true);
                                                  setInputError({ ...inputError, psValue: false });
                                                }}
                                                autoComplete="off"
                                                sx={{
                                                  ...inputFieldStyles,
                                                  background: "#F9FAFB !important",
                                                  paddingTop: "0.5rem !important",
                                                  paddingBottom: "0.5rem !important",
                                                  maxWidth: "155px !important",
                                                  marginTop: "0.5rem !important",
                                                  border: inputError && inputError.psValue && "1px solid #B50609!important",
                                                  '& input[type=number]': {
                                                    MozAppearance: 'textfield',
                                                  },
                                                  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                                }}
                                              />
                                              <Button
                                                sx={{
                                                  background: "#FFFFFF",
                                                  borderRadius: "4px",
                                                  border: "1px solid #D0D5DD",
                                                  minWidth: "90px",
                                                  fontFamily: 'DM Sans',
                                                  fontStyle: 'normal',
                                                  fontWeight: 500,
                                                  fontSize: '14px',
                                                  lineHeight: '10px !important',
                                                  color: '#000000',
                                                  padding: "0.35rem 0.5rem !important",
                                                  boxShadow: "none !important",
                                                  textTransform: "capitalize"
                                                }}
                                              >
                                                Points
                                              </Button>
                                            </SoftBox>
                                          </SoftBox>
                                        </SoftBox>
                                    </SoftBox>
                                  )}
                                </SoftBox>
                              </Grid>
                            </Grid>
                          )}
                          {isStep === 3 && (
                            <Grid container>
                              <Grid item mini={12} mb={2} textAlign="center">
                                <SoftTypography variant="h2" 
                                  sx={{ 
                                      fontSize: screenWidth <= 1280 ? "14px" : "20px",
                                      fontWeight: 700,
                                      lineHeight: "26px",
                                      textAlign: "center",
                                      color: "#000000",
                                      }}>
                                  Finalize & Launch</SoftTypography>
                                <SoftTypography variant="p" 
                                  sx={{ 
                                    fontSize: screenWidth <= 1280 ? "12px" : "14px", 
                                    fontWeight: "500",
                                    lineHeight: "18px",
                                    textAlign: "center",
                                    color: "#667085",
                                  }}>Where your metric pulls info from</SoftTypography>
                              </Grid>
                              {dataMetric && (
                              <Grid item mini={12} mb={3}>
                                <SoftBox> 
                                  <Grid item mini={12} sx={{ display: 'flex', alignItems: 'start', gap: '0.5rem', marginBottom: "1rem" }}>
                                    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.0339 5.99008C14.8166 6.20526 14.5231 6.32595 14.2172 6.32595C13.9113 6.32595 13.6178 6.20526 13.4004 5.99008C13.2932 5.88406 13.208 5.75781 13.1499 5.61864C13.0918 5.47947 13.0619 5.33015 13.0619 5.17933C13.0619 5.02852 13.0918 4.8792 13.1499 4.74003C13.208 4.60086 13.2932 4.47461 13.4004 4.36858C13.6179 4.15296 13.9117 4.03197 14.2179 4.03197C14.5242 4.03197 14.818 4.15296 15.0354 4.36858C15.4854 4.81708 15.4854 5.54308 15.0354 5.99008M1.80545 12.7401C1.52471 12.4625 1.30184 12.1319 1.14974 11.7676C0.997628 11.4033 0.919307 11.0124 0.919307 10.6176C0.919307 10.2228 0.997628 9.83189 1.14974 9.46756C1.30184 9.10323 1.52471 8.77269 1.80545 8.49508L8.94095 1.40008C9.50564 0.839836 10.268 0.524118 11.0634 0.521084L15.9609 0.500084C16.3592 0.497105 16.7541 0.573172 17.1227 0.723882C17.4913 0.874591 17.8264 1.09695 18.1085 1.37807C18.3906 1.65919 18.6141 1.99349 18.7661 2.3616C18.9181 2.72972 18.9955 3.12433 18.9939 3.52258L18.9564 8.58208C18.9491 9.37124 18.6312 10.1257 18.0714 10.6821L11.0379 17.6721C10.4703 18.2359 9.70274 18.5523 8.9027 18.5523C8.10265 18.5523 7.33508 18.2359 6.76745 17.6721L1.80545 12.7401ZM2.87195 9.55558C2.73176 9.69449 2.62049 9.85979 2.54455 10.0419C2.46861 10.2241 2.42951 10.4195 2.42951 10.6168C2.42951 10.8142 2.46861 11.0096 2.54455 11.1917C2.62049 11.3739 2.73176 11.5392 2.87195 11.6781L7.83695 16.6131C8.42645 17.1981 9.38195 17.1981 9.97295 16.6131L17.0049 9.62008C17.2848 9.34191 17.4438 8.96466 17.4474 8.57008L17.4834 3.51058C17.484 3.3118 17.4453 3.11487 17.3694 2.93114C17.2935 2.74741 17.182 2.58053 17.0413 2.44011C16.9006 2.29969 16.7335 2.18851 16.5496 2.11299C16.3657 2.03747 16.1687 1.99909 15.9699 2.00008L11.0724 2.02108C10.6747 2.02117 10.2932 2.17926 10.0119 2.46058L2.87195 9.55558ZM0.995445 13.6251C0.793941 14.1644 0.751851 14.7502 0.874198 15.3127C0.996546 15.8753 1.27816 16.3907 1.68545 16.7976L4.63145 19.7436C5.1886 20.3008 5.85005 20.7428 6.57802 21.0443C7.306 21.3458 8.08624 21.5011 8.8742 21.5011C9.66215 21.5011 10.4424 21.3458 11.1704 21.0443C11.8983 20.7428 12.5598 20.3008 13.1169 19.7436L18.3399 14.5206C18.762 14.099 18.9994 13.5271 18.9999 12.9306V11.7606L13.1169 17.6436C13.0149 17.7476 12.9094 17.8461 12.8004 17.9391L12.0564 18.6831C11.6386 19.101 11.1425 19.4326 10.5964 19.6588C10.0504 19.885 9.46521 20.0014 8.8742 20.0014C8.28318 20.0014 7.69796 19.885 7.15194 19.6588C6.60593 19.4326 6.10982 19.101 5.69195 18.6831L4.94495 17.9346C4.83753 17.8413 4.73346 17.7443 4.63295 17.6436L1.68545 14.6976C1.38124 14.3937 1.14592 14.0279 0.995445 13.6251Z" fill="#667085"/> </svg>
                                    <SoftTypography variant="h2" sx={{ ...inputLabel }}>
                                      Name your Metric
                                    </SoftTypography>
                                  </Grid>
                                  <SoftInput
                                    name="metricName"
                                    placeholder={metricData != null ? metricData.title : "Metric Name"}
                                    type="text"
                                    autoComplete="off"
                                    value={metricName || (newKpi && newKpi.type ? newKpi.type.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "")}
                                    sx={{
                                      ...inputFieldStyles,
                                      border: inputError && inputError.metricName && "1px solid #B50609!important",
                                    }}
                                    onChange={(e) => {
                                      setInputError({ ...inputError, metricName: false });
                                      setmetricName(e.target.value);
                                    }}
                                  />
                                  <SoftTypography 
                                  sx={{
                                    fontFamily: "'DM Sans', sans-serif",
                                    fontStyle: "normal",
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    color: "#667085",
                                  }}>
                                    Give your metric a clear name so players know what they’re working toward.
                                  </SoftTypography>
                                </SoftBox>
                              </Grid>
                              )}
                              <SoftBox sx={{ width: "100%" }}> 
                                <SoftTypography variant="h2" sx={{ ...inputLabel , marginTop: screenWidth <= 1280 ? "0.5rem" : "auto" }}>Effect Type</SoftTypography>
                                <SoftTypography variant="p" sx={{ color: "#667085", fontSize: screenWidth <= 1280 ? "12px" : "14px", fontWeight: "500", marginBottom: screenWidth <= 1280 ? "1rem" : "auto" }}>Is a higher number good or bad for this metric? For example, more sales might be good, while more errors could be bad.</SoftTypography>
                                <Grid container>
                                  <Grid item mini={6} pr={1} sx={{ alignItems: "center", textAlign: "center", marginTop: "1rem" }}>
                                    <SoftBox sx={{ border: inputError && inputError.effectType && "1px solid #B50609!important", background: "#FFFFFF", borderRadius: "4px", display: "flex", justifyContent: "between", padding: "0.5rem 1rem", alignItems: "center" }}>
                                      {effectType === 1 ? (
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12" cy="12.5" r="11.625" fill="#D9D9D9" stroke="url(#paint0_linear_415_6502)" strokeWidth="0.75"/>
                                          <circle cx="12" cy="12.5" r="7.99219" fill="url(#paint1_linear_415_6502)" stroke="#F2F4F7" strokeWidth="0.515625"/>
                                          <defs>
                                            <linearGradient id="paint0_linear_415_6502" x1="19.4883" y1="95.6634" x2="-5.93106" y2="94.0519" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_415_6502" x1="17.1482" y1="69.6749" x2="-0.327605" y2="68.5669" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      ) : (
                                        <svg style={{cursor: "pointer"}} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { setEffectType(1); setInputError({ ...inputError, effectType: false }); }}>
                                          <circle cx="12" cy="12.5" r="11.5" fill="#FCFCFD" stroke="#98A2B3"/>
                                        </svg>
                                      )}
                                      <SoftTypography variant="h2" 
                                        sx={{ 
                                          color: "#000000", 
                                          fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                          fontWeight: "600", 
                                          textAlign: "center", 
                                          marginLeft: "1rem",
                                      }}>
                                      Positive
                                      </SoftTypography>
                                    </SoftBox>
                                  </Grid>
                                  <Grid item mini={6} pl={1} sx={{ alignItems: "center", textAlign: "center", marginTop: "1rem" }}>
                                    <SoftBox sx={{ border: inputError && inputError.effectType && "1px solid #B50609!important", background: "#FFFFFF", borderRadius: "4px", display: "flex", justifyContent: "between", padding: "0.5rem 1rem", alignItems: "center" }}>
                                      {effectType === -1 ? (
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12" cy="12.5" r="11.625" fill="#D9D9D9" stroke="url(#paint0_linear_415_6502)" strokeWidth="0.75"/>
                                          <circle cx="12" cy="12.5" r="7.99219" fill="url(#paint1_linear_415_6502)" stroke="#F2F4F7" strokeWidth="0.515625"/>
                                          <defs>
                                            <linearGradient id="paint0_linear_415_6502" x1="19.4883" y1="95.6634" x2="-5.93106" y2="94.0519" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_415_6502" x1="17.1482" y1="69.6749" x2="-0.327605" y2="68.5669" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      ) : (
                                        <svg style={{cursor: "pointer"}} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => { setEffectType(-1); setInputError({ ...inputError, effectType: false }); }}>
                                          <circle cx="12" cy="12.5" r="11.5" fill="#FCFCFD" stroke="#98A2B3"/>
                                        </svg>
                                      )}
                                      <SoftTypography variant="h2" 
                                        sx={{ 
                                          color: "#000000", 
                                          fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                          fontWeight: "600", 
                                          textAlign: "center", 
                                          marginLeft: "1rem",
                                      }}>
                                      Negative
                                      </SoftTypography>
                                    </SoftBox>
                                  </Grid>
                                </Grid>
                              </SoftBox>
                              <SoftBox sx={{ width: "100%", marginTop: "2rem" }}> 
                                <SoftTypography variant="h2" sx={{ ...inputLabel , marginTop: screenWidth <= 1280 ? "0.5rem" : "auto" }}>Value Type</SoftTypography>
                                <SoftTypography variant="p" sx={{ color: "#667085", fontSize: screenWidth <= 1280 ? "12px" : "14px", fontWeight: "500", marginBottom: screenWidth <= 1280 ? "1rem" : "auto" }}>What kind of value are you measuring? Choose whether this metric tracks money, counts, or other items.</SoftTypography>
                                <Grid container>
                                  <Grid item mini={6} pr={1} sx={{ alignItems: "center", textAlign: "center", marginTop: "1rem" }}>
                                    <SoftBox sx={{ border: inputError && inputError.valueType && "1px solid #B50609!important", background: "#FFFFFF", borderRadius: "4px", display: "flex", justifyContent: "between", padding: "0.5rem 1rem", alignItems: "center" }}>
                                      {valueType === "$" ? (
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12" cy="12.5" r="11.625" fill="#D9D9D9" stroke="url(#paint0_linear_415_6502)" strokeWidth="0.75"/>
                                          <circle cx="12" cy="12.5" r="7.99219" fill="url(#paint1_linear_415_6502)" stroke="#F2F4F7" strokeWidth="0.515625"/>
                                          <defs>
                                            <linearGradient id="paint0_linear_415_6502" x1="19.4883" y1="95.6634" x2="-5.93106" y2="94.0519" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_415_6502" x1="17.1482" y1="69.6749" x2="-0.327605" y2="68.5669" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      ) : (
                                        <svg style={{cursor: "pointer"}} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                          onClick={() => { setValueType("$"); setOzLoader(true); setInputError({ ...inputError, valueType: false }); }}
                                          >
                                          <circle cx="12" cy="12.5" r="11.5" fill="#FCFCFD" stroke="#98A2B3"/>
                                        </svg>
                                      )}
                                      <SoftTypography variant="h2" 
                                        sx={{ 
                                          color: "#000000", 
                                          fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                          fontWeight: "600", 
                                          textAlign: "center", 
                                          marginLeft: "1rem",
                                      }}>
                                      Monetary
                                      </SoftTypography>
                                    </SoftBox>
                                  </Grid>
                                  <Grid item mini={6} pl={1} sx={{ alignItems: "center", textAlign: "center", marginTop: "1rem" }}>
                                    <SoftBox sx={{ border: inputError && inputError.valueType && "1px solid #B50609!important", background: "#FFFFFF", borderRadius: "4px", display: "flex", justifyContent: "between", padding: "0.5rem 1rem", alignItems: "center" }}>
                                      {valueType === "#" ? (
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12" cy="12.5" r="11.625" fill="#D9D9D9" stroke="url(#paint0_linear_415_6502)" strokeWidth="0.75"/>
                                          <circle cx="12" cy="12.5" r="7.99219" fill="url(#paint1_linear_415_6502)" stroke="#F2F4F7" strokeWidth="0.515625"/>
                                          <defs>
                                            <linearGradient id="paint0_linear_415_6502" x1="19.4883" y1="95.6634" x2="-5.93106" y2="94.0519" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_415_6502" x1="17.1482" y1="69.6749" x2="-0.327605" y2="68.5669" gradientUnits="userSpaceOnUse">
                                              <stop stopColor="#7928CA"/>
                                              <stop offset="1" stopColor="#FF0080"/>
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      ) : (
                                        <svg style={{cursor: "pointer"}} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                          onClick={() => { setValueType("#"); setOzLoader(true); setInputError({ ...inputError, valueType: false }); }}>
                                          <circle cx="12" cy="12.5" r="11.5" fill="#FCFCFD" stroke="#98A2B3"/>
                                        </svg>
                                      )}
                                      <SoftTypography variant="h2" 
                                        sx={{ 
                                          color: "#000000", 
                                          fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                          fontWeight: "600", 
                                          textAlign: "center", 
                                          marginLeft: "1rem",
                                      }}>
                                      Item
                                      </SoftTypography>
                                    </SoftBox>
                                  </Grid>
                                </Grid>
                              </SoftBox>
                              {!dataMetric && (
                              <SoftBox sx={{ width: "100%", marginTop: "2rem" }}> 
                                <SoftTypography variant="h2" sx={{ ...inputLabel , marginTop: screenWidth <= 1280 ? "0.5rem" : "auto" }}>Advanced Settings (Optional)</SoftTypography>
                                <SoftTypography variant="p" sx={{ color: "#667085", fontSize: screenWidth <= 1280 ? "12px" : "14px", fontWeight: "500", marginBottom: screenWidth <= 1280 ? "1rem" : "auto" }}>Advanced Setups</SoftTypography>
                                <Grid container style={{ background: "#FFFFFF", borderRadius: "4px", padding: "1rem", marginTop: "0.5rem" }}>
                                  <Grid item mini={6} pr={1} sx={{ alignItems: "center", textAlign: "center" }}>
                                    <SoftBox sx={{ background: "#F9FAFB", borderRadius: "4px", display: "flex", justifyContent: "between", padding: "0.5rem 1rem", alignItems: "start" }}>
                                      <SoftBox>
                                        <svg width="33" height="17" viewBox="0 0 33 17" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                          onClick={() => {
                                            setadvancedPopup(true);
                                        }}>
                                          <rect width="32.5625" height="16.2812" rx="8.14062" fill="white"/>
                                          <rect x="0.25" y="0.25" width="32.0625" height="15.7812" rx="7.89062" stroke="black" strokeOpacity="0.2" strokeWidth="0.5"/>
                                          <circle cx="8.95476" cy="8.14067" r="6.5125" fill="#64748B"/>
                                        </svg>
                                      </SoftBox>
                                      <SoftBox>
                                        <SoftTypography variant="h2" 
                                          sx={{ 
                                            color: "#000000", 
                                            fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                            fontWeight: "600", 
                                            textAlign: "left!important", 
                                            marginLeft: "1rem",
                                        }}>
                                        Composite Metrics
                                        </SoftTypography>
                                        <SoftTypography variant="h2" 
                                          sx={{ 
                                            color: "#475467", 
                                            fontSize: screenWidth <= 1280 ? "14px" : "12px", 
                                            lineHeight: "18px",
                                            fontWeight: "600", 
                                            textAlign: "left!important", 
                                            marginLeft: "1rem",
                                            marginTop: "0.5rem"
                                        }}>
                                        Combine multiple metrics into one. For example,<br/> track sales + upsells together as a single metrics  
                                        </SoftTypography>
                                      </SoftBox>
                                    </SoftBox>
                                  </Grid>
                                  <Grid item mini={6} pr={1} sx={{ alignItems: "center", textAlign: "center" }}>
                                    <SoftBox sx={{ background: "#F9FAFB", borderRadius: "4px", display: "flex", justifyContent: "between", padding: "0.5rem 1rem", alignItems: "start" }}>
                                      <svg width="33" height="17" viewBox="0 0 33 17" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                        onClick={() => {
                                          setIsMonitorMode(true);
                                      }}>
                                        <rect width="32.5625" height="16.2812" rx="8.14062" fill="white"/>
                                        <rect x="0.25" y="0.25" width="32.0625" height="15.7812" rx="7.89062" stroke="black" strokeOpacity="0.2" strokeWidth="0.5"/>
                                        <circle cx="8.95476" cy="8.14067" r="6.5125" fill="#64748B"/>
                                      </svg>
                                      <SoftBox sx={{marginBottom: "1.5rem"}}>
                                        <SoftTypography variant="h2" 
                                          sx={{ 
                                            color: "#000000", 
                                            fontSize: screenWidth <= 1280 ? "14px" : "16px", 
                                            fontWeight: "600", 
                                            textAlign: "left!important", 
                                            marginLeft: "1rem",
                                        }}>
                                        Monitor Mode
                                        </SoftTypography>
                                        <SoftTypography variant="h2" 
                                          sx={{ 
                                            color: "#475467", 
                                            fontSize: screenWidth <= 1280 ? "14px" : "12px", 
                                            lineHeight: "18px",
                                            fontWeight: "600", 
                                            textAlign: "left!important", 
                                            marginLeft: "1rem",
                                            marginTop: "0.25rem"
                                        }}>
                                        Monitor the performance of your metrics  
                                        </SoftTypography>
                                      </SoftBox>
                                    </SoftBox>
                                  </Grid>
                                </Grid>
                              </SoftBox>
                              )}
                            </Grid>
                          )}
                          <SoftBox sx={{width: "70%", margin: "0 auto", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem", marginTop: ozLoader ? "2rem" : "0rem"}}>
                            <Grow in={ozLoader && (isStep === 1 || isStep === 2 || isStep === 3)} timeout={1000}>
                              <img
                                src={
                                  (() => {
                                    if (isStep === 1) return ozLoader30;
                                    if (isStep === 2) return ozLoader60;
                                    if (isStep === 3) return ozLoader100;
                                    return ozLoader30;
                                  })()
                                }
                                alt={
                                  (() => {
                                    if (isStep === 1) return "30%";
                                    if (isStep === 2) return "60%";
                                    if (isStep === 3) return "100%";
                                    return ozLoader30;
                                  })()
                                }
                                style={{ display: "block", width: "35%" }}
                              />
                            </Grow>
                            <Grow in={ozLoader} timeout={1000}>
                              <img 
                               src={
                                (() => {
                                  if (isStep === 1) return ozLoaderText;
                                  if (isStep === 2) return ozLoaderText60;
                                  if (isStep === 3) return ozLoaderText100;
                                  return ozLoaderText;
                                })()
                              }
                              alt={
                                (() => {
                                  if (isStep === 1) return "ozLoaderText30";
                                  if (isStep === 2) return "ozLoaderText60";
                                  if (isStep === 3) return "ozLoaderText100";
                                  return ozLoader30;
                                })()
                              }
                              style={{ display: "block", marginLeft: "-10%" }} draggable={false} />
                            </Grow>
                          </SoftBox>
                          <Grid container spacing={2} mt={ozLoader ? 3 : 5}>
                            <Grid item xs={6}>
                              <SoftButton
                                onClick={() => {
                                  setsaveDialog(true);
                                  setIsDraft(true);
                                }}
                                disabled={isStep === 1 || !metricName}
                                sx={{
                                  background: "#FFFFFF",
                                  border: "0.6px solid rgba(233, 236, 239, 0.1)",
                                  boxShadow: "0px 0.577251px 1.1545px rgba(0, 0, 0, 0.05)",
                                  borderRadius: "2.5px",
                                  fontWeight: 500,
                                  fontSize: "13.5px",
                                  lineHeight: "18px",
                                  letterSpacing: "-0.02em",
                                  color: "#475467",
                                  textTransform: "none",
                                  padding: "0 1rem !important",
                                }}
                              >
                                Save as Draft
                              </SoftButton>
                            </Grid>
                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                              <SoftButton
                                onClick={() => {
                                  setOzLoader(false);
                                  if (isStep > 1) { 
                                    setStep(isStep - 1); 
                                  }
                                }}
                                disabled={isStep === 1}
                                sx={{
                                  background: "#FFFFFF",
                                  border: "0.6px solid rgba(233, 236, 239, 0.1)",
                                  boxShadow: "0px 0.577251px 1.1545px rgba(0, 0, 0, 0.05)",
                                  borderRadius: "2.5px",
                                  fontWeight: 500,
                                  fontSize: "13.5px",
                                  lineHeight: "18px",
                                  letterSpacing: "-0.02em",
                                  color: "#475467",
                                  textTransform: "none",
                                  padding: "0 3rem !important",
                                }}
                              >
                                Previous
                              </SoftButton>
                              <SoftButton
                                onClick={() => {
                                  inputChecker();
                                }}
                                disabled={
                                  !metricData && inputs.length === 0 &&
                                  !(
                                    newKpi?.isNew ||
                                    newKpi?.isZapier ||
                                    newKpi?.integrationId ||
                                    metricData?.integrationId
                                  )
                                }
                                sx={{
                                  background: `${theme.palette.primary.main}!important`,
                                  border: "0.6px solid rgba(233, 236, 239, 0.1)",
                                  boxShadow: "0px 0.577251px 1.1545px rgba(0, 0, 0, 0.05)",
                                  borderRadius: "2.5px",
                                  fontWeight: 500,
                                  fontSize: "13.5px",
                                  lineHeight: "18px",
                                  letterSpacing: "-0.02em",
                                  color: "#FFFFFF",
                                  textTransform: "none",
                                  padding: "0 3rem !important",
                                  "&:hover": {
                                    background: `${theme.palette.primary.main}!important`,
                                  },
                                  "&:disabled": {
                                    background: `${theme.palette.primary.main}!important`,
                                    color: "#FFFFFF!important",
                                  },
                                }}
                              >
                                {isStep === 3 ? "Go Live" : "Next"}
                              </SoftButton>
                            </Grid>
                          </Grid>
                        </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </Grid>
          )}
        </Grid>
      </SoftBox>
        <Dialog
          open={openManualSubmissionDialog}
          onClose={() => setOpenManualSubmissionDialog(false)}
          sx={{
            ".MuiPaper-root": {
              borderRadius: "24px",
              background: 'linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)',
              boxShadow: '0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)',
              padding: '1.75rem',
              maxWidth: { mini: "90%", xs: "90%", sm: "610px" },
              width: "100%",
              backdropFilter: 'blur(18px) saturate(160%)',
              WebkitBackdropFilter: 'blur(18px) saturate(160%)',
              border: "1px solid rgba(255,255,255,0.6)",
            },
          }}
        >
          <SoftBox display="flex" alignItems="center" sx={{ padding: "0 !important" }}>
            <SoftBox display="flex" alignItems="center">
              <SoftBox display="flex" flexDirection="column">
                <SoftTypography
                  component="h3"
                  sx={{
                    fontSize: "18px",
                    color: "#0F172A",
                    margin: 0,
                    padding: 0,
                    fontWeight: "500",
                  }}
                >
                  Manual Submission
                </SoftTypography>
                <SoftTypography
                  component="p"
                  sx={{
                    fontSize: "14px",
                    color: "#475467",
                    margin: 0,
                    padding: 0,
                    fontWeight: "500",
                  }}
                >
                  Track and measure progress on your own terms.
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <div className="ml-auto">
              <SoftButton
                variant="outlined"
                color="white"
                sx={{
                  "& svg": { fontSize: "1rem !important", color: "#475467 !important" },
                  borderRadius: "50%",
                  minWidth: "max-content",
                  minHeight: "max-content",
                  padding: "0.25rem",
                  color: "#475467 !important",
                  borderColor: "rgba(15,23,42,0.10) !important",
                }}
                onClick={() => setOpenManualSubmissionDialog(false)}
              >
                <CloseIcon />
              </SoftButton>
            </div>
          </SoftBox>
          <Divider
            sx={{
              marginY: "1rem",
              borderColor: "rgba(15,23,42,0.10)",
            }}
          />
          <SoftBox>
            <SoftBox mb={2}>
              <Grid container>
              {FORM_OPTIONS_ANCHOR
                .filter((formType) => formType.name !== "Email Submission")
                .map((formType, index) => (
                <Grid item mini={6} mb={2}>
                  <SoftButton
                    disabled={index === 2} // Disable email submission for now
                    onClick={() => handleFormSelect(index)}
                    sx={{
                      width: "250px !important",
                      background: "rgba(15,23,42,0.03)",
                      border:
                        formIdx === index
                          ? `1px solid ${primaryColor}`
                          : "1px solid rgba(15,23,42,0.10)",
                      borderRadius: "8px",
                      padding: "0.5rem",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      flex: "0 0 auto",
                      textAlign: "start",
                      margin: "4px",
                      minHeight: "107px",
                      boxShadow:
                        formIdx === index
                          ? `0rem 0rem 0rem 0.1rem ${primaryColor}`
                          : "none",
                      "&:hover": {
                        borderColor: primaryColor,
                        background: "rgba(15,23,42,0.06)",
                        boxShadow: `0rem 0rem 0rem 0.1rem ${primaryColor}`,
                      },

                      "&:focus:not(:hover)": {
                        borderColor: primaryColor,
                        background: "rgba(15,23,42,0.06)",
                        boxShadow: `0rem 0rem 0rem 0.1rem ${primaryColor}`,
                      },
                      "&:disabled": {
                        backgroundColor: "transparent !important",
                      },
                    }}
                  >
                    <SoftBox
                      display="flex"
                      gap="0.15rem"
                      alignItems="center"
                      marginBottom="0.25rem"
                      width="100%"
                    >
                      {formType.icon}
                      <SoftTypography
                        variant="button"
                        sx={{
                          color: "#0F172A",
                          fontSize: "15px",
                          fontWeight: 500,
                        }}
                      >
                        {formType.name}
                      </SoftTypography>
                    </SoftBox>
                    <SoftTypography
                      variant="caption"
                      sx={{
                        color: "#475467",
                        fontSize: "12px",
                        fontWeight: 500,
                        marginLeft: "0.25rem",
                      }}
                    >
                      {formType.desc}
                    </SoftTypography>
                  </SoftButton>
                </Grid>
              ))}
              </Grid>
              <SoftBox>
                <SoftTypography
                  component="h3"
                  sx={{
                    fontFamily: 'DM Sans',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: '18px',
                    letterSpacing: '-0.02em',
                    color: '#0F172A',
                    marginBottom: "-1rem"
                  }}
                  >
                    Setup Section
                  </SoftTypography>
                <Divider />
                {formIdx <= 2 && (
                  <>
                    {/* eslint-disable */}
                    <SoftInput
                      size="large"
                      placeholder={FORM_OPTIONS_ANCHOR[formIdx].placeholder}
                      value={inputs[0]?.value}
                      onChange={(e) => {
                        // Match input format to complex form builder so any approach can be validated in the same way
                        const formInputs = [
                          {
                            value: e.target.value,
                            type: FORM_OPTIONS_ANCHOR[formIdx].type,
                          },
                        ];
                        handleInputs(formInputs);
                      }}
                      sx={{
                        border: "1px solid #E4E7EC",
                        backgroundColor:
                          "#F6F7F9 !important",
                        color: "#1d2939 !important",
                        "& .MuiInputBase-input::placeholder": {
                          color: "#98A2B3 !important",
                          opacity: "1",
                        },
                        "&.Mui-focused": {
                          borderColor: primaryColor,
                          boxShadow: `0rem 0rem 0rem 0.125rem ${primaryColor}`,
                        },
                      }}
                    />
                  </>
                )}
                {formIdx === 3 && (
                  <SoftBox
                  sx={{
                    background: "rgba(15,23,42,0.03)",
                    border: "0.918685px solid rgba(15,23,42,0.10)",
                    borderRadius: "7.34948px",
                  }}>
                  <KpiSubmissionFormBuilder
                    inputs={inputs}
                    updateInputs={(values) => handleInputs(values)}
                  />
                  </SoftBox>
                )}
              </SoftBox>
            </SoftBox>
            <SoftBox display="flex" justifyContent="space-between" gap="1rem" sx={{marginTop: "4rem"}}>
              <Button
                variant="outlined"
                color="white"
                onClick={() => setOpenManualSubmissionDialog(false)}
                sx={{
                  background: "rgba(15,23,42,0.03)",
                  border: "0.685293px solid rgba(15,23,42,0.10)",
                  boxShadow: "0px 0.685293px 1.37059px rgba(0, 0, 0, 0.05)",
                  borderRadius: "2.7px",
                  textTransform: "none",
                  fontFamily: "'DM Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "16px",
                  letterSpacing: "-0.02em",
                  color: "#475467",
                  paddingY: "0rem",
                  paddingX: "4rem"
                }}
              >
                Cancel
              </Button>
              <div style={{ flex: 1 }} />
              <Button
                variant="contained"
                color="white"
                onClick={() => { setOpenManualSubmissionDialog(false); setOzLoader(true); }}
                sx={{
                  background: "#FFFFFF",
                  border: "0.685293px solid rgba(233, 236, 239, 0.1)",
                  boxShadow: "0px 0.685293px 1.37059px rgba(0, 0, 0, 0.05)",
                  borderRadius: "2.7px",
                  textTransform: "none",
                  fontFamily: "'DM Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "16px",
                  letterSpacing: "-0.02em",
                  color: "#344054",
                  paddingY: "0rem",
                  paddingX: "4rem"
                }}
              >
                Save
              </Button>
            </SoftBox>
          </SoftBox>
        </Dialog>
        <Dialog
          open={openDSDialog}
          onClose={() => setopenDSDialog(false)}
          sx={{
            ".MuiPaper-root": {
              borderRadius: "9px",
              background: '#FFFFFF',
              boxShadow: 24,
              padding: '1.75rem',
              maxWidth: { mini: "90%", xs: "90%", sm: "70%" },
              width: "100%",
            },
          }}
        >
          <SoftBox display="flex" alignItems="center" sx={{ padding: "0 !important" }}>
            <SoftBox display="flex" alignItems="center">
              <SoftBox display="flex" alignItems="center" flexDirection="column">
                <SoftTypography
                  component="h3"
                  sx={{
                    fontSize: "24px",
                    color: "#000000",
                  }}
                >
                  &nbsp;
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <div className="ml-auto">
              <SoftButton
                variant="outlined"
                color="black"
                sx={{
                  "& svg": { fontSize: "1rem !important" },
                  borderRadius: "50%",
                  minWidth: "max-content",
                  minHeight: "max-content",
                  padding: "0.25rem",
                }}
                onClick={() => setopenDSDialog(false)}
              >
                <CloseIcon />
              </SoftButton>
            </div>
          </SoftBox>
          <DialogContent sx={{ padding: "0 !important" }}>
            {ismetricType !== "Display Metric" ? (
              <ConnectedApplications
                apps={allApps}
                connectedApps={connectedApps}
                groupKpis={groupKpis}
                integrationsObj={integrationsObj}
                currentAppIntegrations={currentAppIntegrations}
                isLoading={isLoading}
                functions={{
                  createCustomKpi: () => setopenDSDialog(true),
                  handleLocalKpi: (kpi) => {
                    // Minimal selected Integrated Metrics data
                    setmetricName(kpi && kpi.type ? kpi.type.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "")
                    setNewKpi({ ...kpi, isNew: true });
                    setopenDSDialog(false);
                    setOzLoader(true);
                  },
                }}
              />
            ) : (
              <Grid container>
                {filteredApps.map((app) => (
                  <Grid
                    item
                    p={1}
                    mini={12}
                    lg={4}
                    xl={3}>
                    <SoftBox
                      variant="contained"
                      borderRadius="md"
                      className="flex flex-col justify-between items-start"
                      sx={{
                        minHeight: "168px",
                        border: "0.835728px solid rgba(255, 255, 255, 0.502431)",
                        background: "#e5e7eb",
                        paddingX: { xs: "1rem", xxl: "1.5rem" },
                        paddingY: { xs: "0.75rem", xxl: "1rem" },
                      }}
                    >
                      <SoftBox className="flex flex-col mt-1">
                        <SoftTypography
                          variant="body2"
                          sx={{
                            color: "#000000",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {app.label}
                        </SoftTypography>
                        <SoftTypography
                          variant="p"
                          sx={{
                            marginTop: "1rem",
                            color: "#666666",
                            fontWeight: 400,
                            textTransform: "capitalize",
                          }}
                        >
                          {app.description}
                        </SoftTypography>
                      </SoftBox>
                      <SoftBox className="w-full flex justify-between items-center">
                        <SoftTypography
                          sx={{
                            color: "#343A40",
                            fontSize: "0.9rem",
                            fontWeight: 600,
                          }}
                        >
                        &nbsp;
                        </SoftTypography>
                        <SoftButton
                          variant="outlined"
                          color="primary"
                          size="small"
                          className="!normal-case !py-0 !px-2 !font-['Inter'] !text-[10px]"
                          onClick={() => {
                            setopenDSDialog(false);
                            setStep(2);
                            setDataSource(app.value);
                            setSourceId(app.sourceId);
                            setSourceLabel(app.label);
                            setSourceType(app.type);
                            setIntegrationId(app.integrationId);
                            setKpiModelId(app.kpiModelId);
                          }}
                        >
                          Add Metric
                        </SoftButton>
                      </SoftBox>
                    </SoftBox>
                  </Grid>
                ))}
              </Grid>
            )}
          </DialogContent>
        </Dialog>
        <Dialog
          open={advancedPopup}
          onClose={() => setadvancedPopup(false)}
          sx={{
            ".MuiPaper-root": {
              borderRadius: "24px",
              background: 'linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)',
              boxShadow: '0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)',
              padding: '1.75rem',
              maxWidth: { mini: "90%", xs: "90%", sm: "600px" },
              width: "100%",
              minHeight: "575px",
              backdropFilter: 'blur(18px) saturate(160%)',
              WebkitBackdropFilter: 'blur(18px) saturate(160%)',
              border: "1px solid rgba(255,255,255,0.6)",
            },
          }}
        >
          <SoftBox display="flex" alignItems="center" sx={{ padding: "0 !important" }}>
            <SoftBox display="flex" alignItems="center">
              <SoftBox display="flex" flexDirection="column">
                <SoftTypography
                  component="h3"
                  sx={{
                    fontSize: "18px",
                    color: "#0F172A",
                    margin: 0,
                    padding: 0,
                    fontWeight: "500",
                  }}
                >
                  Advanced Settings
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <div className="ml-auto">
              <SoftButton
                variant="outlined"
                color="white"
                sx={{
                  "& svg": { fontSize: "1rem !important", color: "#475467 !important" },
                  borderRadius: "50%",
                  minWidth: "max-content",
                  minHeight: "max-content",
                  padding: "0.25rem",
                  color: "#475467 !important",
                  borderColor: "rgba(15,23,42,0.10) !important",
                }}
                onClick={() => setadvancedPopup(false)}
              >
                <CloseIcon />
              </SoftButton>
            </div>
          </SoftBox>
          <Divider
            sx={{
              marginY: "1rem",
              borderColor: "rgba(15,23,42,0.10)",
            }}
          />
          <DialogContent sx={{ padding: "0 !important" }}>
            <SoftBox
              className="shadow"
              sx={{
                border: "1px solid rgba(15,23,42,0.10)",
                backgroundColor: "rgba(15,23,42,0.03) !important",
                borderRadius: "0.5rem",
                padding: "0.75rem !important",
                marginBottom: "15px",
              }}
            >
              <SoftBox display="flex" alignItems="flex-start" gap={2}>
                <SoftBox>
                  <Switch
                    onChange={(e) => setFormValue("advanced", e.target.checked)}
                    checked={metricData && metricData.optional?.operand ? true : false}
                  />
                </SoftBox>
                <SoftBox display="flex" flexDirection="column" gap={1}>
                  <SoftTypography
                    variant="h4"
                    sx={{
                      color: "#0F172A",
                      fontSize: "15px",
                      fontWeight: 500,
                    }}
                  >
                    Advanced Settings/Composite setup
                  </SoftTypography>
                  <SoftTypography
                    variant="p"
                    sx={{
                      color: "#475467",
                      fontSize: "12px",
                      fontWeight: 500,
                    }}
                  >
                    When toggling the advanced settings, you gain access to
                    configure composite metrics, allowing you to combine
                    multiple performance indicators into a comprehensive
                    measure
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
              <Collapse in={watchAdvanced}>
                <Divider
                  sx={{
                    backgroundColor: "rgba(15,23,42,0.10)",
                  }}
                />
                <SoftBox display="flex" gap={1}>
                  <SoftSelect
                    options={!metricData ? dataSourceOneOptions : []}
                    onChange={(option) =>
                      setFormValue("dataSourceOne", option.value)
                    }
                    defaultValue={metricData ? dataSourceOneOptions[0].options[0] ?? null : null}
                    placeholder="Data Source 1"
                    styles={{
                      color: "#1d2939 !important",
                      height: "fit-content !important",
                      placeholder: {
                        color: "#98A2B3 !important",
                        opacity: "1",
                      },
                      input: {
                        color: "#1d2939 !important",
                        opacity: "1",
                      },
                      singleValue: {
                        color: "#1d2939 !important",
                        opacity: "1",
                      },
                    }}
                  />
                  <SoftSelect
                    options={!metricData ? calculationOptions : []}
                    defaultValue={
                      metricData && metricData.optional && metricData.optional.operand ? {
                        value: metricData.optional.operand, 
                        label: metricData.optional.operand.charAt(0).toUpperCase() + metricData.optional.operand.slice(1)
                        } ?? null : null}
                    onChange={(option) =>
                      setFormValue("calculationMethod", option.value)
                    }
                    placeholder="Select Calculation"
                    styles={{
                      color: "#1d2939 !important",
                      height: "fit-content !important",
                      placeholder: {
                        color: "#98A2B3 !important",
                        opacity: "1",
                      },
                      input: {
                        color: "#1d2939 !important",
                        opacity: "1",
                      },
                      singleValue: {
                        color: "#1d2939 !important",
                        opacity: "1",
                      },
                    }}
                  />
                  <SoftSelect
                    options={!metricData ? dataSourceTwoOptions : []}
                    defaultValue={metricData ? dataSourceTwoOptions[0].options[0] ?? null : null}
                    onChange={(option) =>
                      setFormValue("dataSourceTwo", option.value)
                    }
                    placeholder="Data Source 2"
                    styles={{
                      color: "#1d2939 !important",
                      height: "fit-content !important",
                      placeholder: {
                        color: "#98A2B3 !important",
                        opacity: "1",
                      },
                      input: {
                        color: "#1d2939 !important",
                        opacity: "1",
                      },
                      singleValue: {
                        color: "#1d2939 !important",
                        opacity: "1",
                      },
                    }}
                  />
                </SoftBox>
                <Divider
                  sx={{
                    backgroundColor: "rgba(15,23,42,0.10)",
                  }}
                />
                <SoftTypography
                  variant="p"
                  sx={{
                    color: "#475467",
                    fontSize: "12px",
                    fontWeight: 400,
                  }}
                >
                  Need more flexibility? Easily incorporate an additional
                  data source for more comprehensive analysis and insights
                </SoftTypography>
              </Collapse>
            </SoftBox>
          </DialogContent>
          {!metricData && (
            <DialogActions sx={{  }}>
              <SoftBox display="flex" justifyContent="flex-end" gap="1rem">
                <SoftButton
                  onClick={() => setadvancedPopup(false)}
                  sx={{
                    background: "#F9F9F9",
                    color: "#667085",
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: "400",
                    letterSpacing: "0.095px",
                    paddingX: "1.75rem",
                    "&:hover": {
                      background: "#F9F9F9",
                      color: "#667085",
                      textTransform: "none",
                      fontSize: "1rem",
                      fontWeight: "400",
                      letterSpacing: "0.095px",
                      paddingX: "1.75rem",
                    },
                  }}
                >
                  Cancel
                </SoftButton>
                <SoftButton
                  onClick={() => {
                    setStep(6);
                    setadvancedPopup(false);
                  }}
                  sx={{
                    background: "#344054",
                    color: "#F2F4F7",
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: "400",
                    letterSpacing: "0.095px",
                    paddingX: "1.75rem",
                    "&:hover": {
                      background: "#344054",
                      color: "#F2F4F7",
                      textTransform: "none",
                      fontSize: "1rem",
                      fontWeight: "400",
                      letterSpacing: "0.095px",
                      paddingX: "1.75rem",
                    },
                  }}
                >
                  Okay
                </SoftButton>
              </SoftBox>
            </DialogActions>
          )}
        </Dialog>
      {dialog && (
        <SoftDialog
          open={dialog}
          onClose={closeDialog}
          title={`${metricName} ${metricData ? "Updated" : (isDraft ? "Saved" : "Created")}`}
          type="success"
          icon={<CheckIcon fontSize="large" sx={{ color: "#299E47" }} />}
          description={
            <SoftBox display="flex" justifyContent="center" mt="25px" mb="35px">
              <SoftTypography
                variant="p"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#FFF",
                  textAlign: "center",
                }}
              >
                {isDraft
                  ? "Your metric has been saved as a draft."
                  : metricData
                    ? "Your Metric has been Updated."
                    : `You have created a new ${metricName}.`}
                <br/>
                {metricName === "display"
                  ? "This will help you visualize and analyze your performance data more effectively"
                  : isDraft
                    ? "You can come back anytime to finish setting up and publish it."
                    : "You are now ready to track your progress and level up your performance."}
              </SoftTypography>
            </SoftBox>
          }
          footer={
            <SoftBox display="flex" gap="10px" justifyContent="center">
              <SoftButton
                size="small"
                color="white"
                onClick={() => navigate("/workspace-kpi")}
                sx={{
                  width: "min-content",
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#344054",
                }}
              >
                Okay
              </SoftButton>
            </SoftBox>
          }
        />
      )}
      {saveDialog && (
        <SoftDialog
          open={saveDialog}
          onClose={closesaveDialog}
          title={`Save this metric as a draft?`}
          type="error"
          icon={<WarningAmberIcon fontSize="large" sx={{ color: "#981B14" }} />}
          description={
            <SoftBox display="flex" justifyContent="center" mt="25px" mb="35px">
              <SoftTypography
                variant="p"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#FFF",
                  textAlign: "center",
                }}
              >
                Your progress so far will be saved as a draft. You can come back anytime to finish setting up and publish this metric later
              </SoftTypography>
            </SoftBox>
          }
          footer={
            <SoftBox
              display="flex"
              gap="1rem"
              justifyContent="center"
              alignItems="center"
              sx={{
                width: "100%",
                flex: 1,
                flexGrow: 1,
              }}
            >
              <SoftButton
                size="small"
                color="white"
                onClick={() => { closesaveDialog(); setIsDraft(false); }}
                sx={{
                  flex: 1,
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#FFFFFF",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "0.685293px solid rgba(233, 236, 239, 0.1)",
                  boxShadow: "0px 0.685293px 1.37059px rgba(0, 0, 0, 0.05)",
                  borderRadius: "3px",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.1)",
                  },
                  width: "100%",
                }}
              >
                Keep Creating
              </SoftButton>
              <SoftButton
                size="small"
                color="white"
                onClick={() => submitData()}
                sx={{
                  flex: 1,
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#344054",
                  width: "100%",
                }}
              >
                Save as Draft
              </SoftButton>
            </SoftBox>
          }
        />
      )}
      {submitPopup && (
        <SoftDialog
          open={submitPopup}
          onClose={closeSubmitDialog}
          title={`Submit Metric Confirmation`}
          type="success"
          icon={<CheckIcon fontSize="large" sx={{ color: "#299E47" }} />}
          description={
            <SoftBox display="flex" justifyContent="center" mt="25px" mb="35px">
              <SoftTypography
                variant="p"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#FFF",
                  textAlign: "center",
                }}
              >
                Are you sure you want to submit this metric?
              </SoftTypography>
            </SoftBox>
          }
          footer={
            <SoftBox display="flex" gap="10px" justifyContent="center">
              <SoftButton
                size="small"
                color="white"
                onClick={() => { closeSubmitDialog(); }}
                sx={{
                  width: "min-content",
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#344054",
                }}
              >
                Cancel
              </SoftButton>
              <SoftButton
                size="small"
                color="secondary"
                onClick={() => { submitData(); closeSubmitDialog(); }}
                sx={{
                  width: "min-content",
                  borderRadius: "4px",
                  textTransform: "none",
                  color: "#FFFFFF",
                  background: "linear-gradient(273.63deg, rgba(121, 40, 202, 0.7) 0%, rgba(255, 0, 128, 0.7) 100%)",
                }}
              >
                Proceed
              </SoftButton>
            </SoftBox>
          }
        />
      )}
      <Dialog
        open={openDialog}
        onClose={() => setopenDialog(false)}
        sx={{
          ".MuiPaper-root": {
            borderRadius: "9px",
            background: '#FFFFFF',
            boxShadow: 24,
            padding: '1.75rem',
            maxWidth: { mini: "100%", xs: "90%", sm: "995px", lg: "1250px" },
            width: "100%",
          },
        }}
      >
        <SoftBox display="flex" alignItems="center" sx={{ padding: "0 !important" }}>
          <SoftBox display="flex" alignItems="center">
            <SoftBox display="flex" alignItems="center" flexDirection="column">
              <SoftTypography
                component="h3"
                sx={{
                  fontSize: "24px",
                  color: "#000000",
                }}
              >
                &nbsp;
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <div className="ml-auto">
            <SoftButton
              variant="outlined"
              color="black"
              sx={{
                "& svg": { fontSize: "1rem !important" },
                borderRadius: "50%",
                minWidth: "max-content",
                minHeight: "max-content",
                padding: "0.25rem",
              }}
              onClick={() => setopenDialog(false)}
            >
              <CloseIcon />
            </SoftButton>
          </div>
        </SoftBox>
        <SoftBox sx={{ textAlign: "center", marginTop: "-2rem" }}>
          <SoftTypography
            component="h3"
            sx={{
              fontSize: "24px",
              color: "#000000",
              margin: 0,
              padding: 0,
              fontWeight: "500",
            }}
          >
            Choose a Metric Type
          </SoftTypography>
          <SoftTypography
            component="h3"
            sx={{
              fontSize: "18px",
              color: "#98A2B3",
              fontWeight: "400",
            }}
          >
            Pick the type of metric you want to create. Each type serves a different purpose,<br/> helping you track performance the way you need.
          </SoftTypography>
        </SoftBox>
        <DialogContent sx={{ padding: "0 !important" }}>
          <ExploreTypes 
            onMetricTypeSelect={handleMetricTypeSelect} 
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isMonitorMode}
        onClose={() => setIsMonitorMode(false)}
        sx={{
            ".MuiPaper-root": {
              borderRadius: "24px",
              background: 'linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)',
              boxShadow: '0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)',
              padding: '1.75rem',
              maxWidth: { mini: "90%", xs: "90%", sm: "600px" },
              width: "100%",
              backdropFilter: 'blur(18px) saturate(160%)',
              WebkitBackdropFilter: 'blur(18px) saturate(160%)',
              border: "1px solid rgba(255,255,255,0.6)",
            },
          }}
      >
        <SoftBox display="flex" alignItems="center" sx={{ padding: "0 !important", marginBottom: "1rem" }}>
          <SoftBox display="flex" alignItems="center">
            <SoftBox display="flex" flexDirection="column">
              <SoftTypography
                component="h3"
                sx={{
                  fontSize: "18px",
                  color: "#0F172A",
                  margin: 0,
                  padding: 0,
                  fontWeight: "500",
                }}
              >
                Monitor Mode
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <div className="ml-auto">
            <SoftButton
              variant="outlined"
              color="white"
              sx={{
                "& svg": { fontSize: "1rem !important", color: "#475467 !important" },
                borderRadius: "50%",
                minWidth: "max-content",
                minHeight: "max-content",
                padding: "0.25rem",
                color: "#475467 !important",
                borderColor: "rgba(15,23,42,0.10) !important",
              }}
              onClick={() => setIsMonitorMode(false)}
            >
              <CloseIcon />
            </SoftButton>
          </div>
        </SoftBox>
        <SoftBox sx={{ textAlign: "center", margin: "0 auto", width: "55%"  }}>
          <SoftTypography
            component="h3"
            sx={{
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "18px",
              textAlign: "center",
              color: "#475467",
            }}
          >
            Our AI Models That give you summary of your Teams Reports and where they need to Improve
          </SoftTypography>
        </SoftBox>
        <SoftBox sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "1rem", marginTop: "2rem", marginBottom: "1rem" }}>
          <SoftBox 
            sx={{ 
              width: "50%",
              height: "100%",
              background: "rgba(15,23,42,0.03)",
              border: "0.99454px solid rgba(15,23,42,0.10)",
              boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 4px rgba(8, 12, 19, 0.1)",
              borderRadius: "5.80505px",
              textAlign: "center",
              padding: "1rem",
            }}
          >
            <img src={YetiMode} alt="Yeti Mode" style={{ margin: "0 auto", display: "block" }} />
            <SoftTypography
              component="h3"
              sx={{
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "21px",
                textAlign: "center",
                color: "#0F172A",
                marginTop: "0.5rem",
                marginBottom: "0.5rem",
              }}
            >
              Yeti Mode
            </SoftTypography>
            <SoftTypography
              component="h3"
              sx={{
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "16px",
                textAlign: "center",
                color: "#475467",
                maxWidth: "85%",
                margin: "0 auto",
              }}
            >
              Yeti mode will be yeti will talk trash at you once in a while depending on how good your score is.
            </SoftTypography>
            <SoftButton
              variant="contained"
              color="primary"
              sx={{
                marginTop: "1rem",
                marginBottom: "0.5rem",
                background: "rgba(15,23,42,0.03)",
                border: "0.5px solid rgba(236, 39, 134, 0.3)",
                borderRadius: "4px",
                padding: "0.25rem 2rem !important",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "16px",
                textAlign: "center",
                color: "#475467",
                textTransform: "none",
                "&:hover": {
                  background: "rgba(15,23,42,0.06)",
                },
              }}
            >
              Activate
            </SoftButton>
          </SoftBox>  
          <SoftBox 
            sx={{ 
              width: "50%",
              height: "100%",
              background: "rgba(15,23,42,0.03)",
              border: "0.99454px solid rgba(15,23,42,0.10)",
              boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 4px rgba(8, 12, 19, 0.1)",
              borderRadius: "5.80505px",
              textAlign: "center",
              padding: "1rem",
            }}
          >
            <img src={`${process.env.PUBLIC_URL || ""}/img/wizardMode.svg`} alt="Wizard Mode" style={{ margin: "0 auto", display: "block" }} />
            <SoftTypography
              component="h3"
              sx={{
                fontWeight: "700",
                fontSize: "16px",
                lineHeight: "21px",
                textAlign: "center",
                color: "#0F172A",
                marginTop: "0.5rem",
                marginBottom: "0.5rem",
              }}
            >
              Wizard Mode
            </SoftTypography>
            <SoftTypography
              component="h3"
              sx={{
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "16px",
                textAlign: "center",
                color: "#475467",
                maxWidth: "85%",
                margin: "0 auto",
              }}
            >
              Wizard Guide Mode helps to monitor players and give them guide
            </SoftTypography>
            <SoftButton
              variant="contained"
              color="primary"
              sx={{
                marginTop: "1rem",
                marginBottom: "0.5rem",
                background: "rgba(15,23,42,0.03)",
                border: "0.5px solid rgba(236, 39, 134, 0.3)",
                borderRadius: "4px",
                padding: "0.25rem 2rem !important",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "16px",
                textAlign: "center",
                color: "#475467",
                textTransform: "none",
                "&:hover": {
                  background: "rgba(15,23,42,0.06)",
                },
              }}
            >
              Activate
            </SoftButton>
          </SoftBox>
        </SoftBox>
        <SoftBox sx={{ display: "flex", justifyContent: "flex-end" }}>
          <SoftButton
            variant="contained"
            color="primary"
            sx={{
              marginTop: "1rem",
              marginBottom: "0.5rem",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "21px",
              textAlign: "center",
              color: "#344054",
              borderRadius: "4px",
              background: "#F9FAFB",
              boxShadow: "0px 0.375465px 0.750929px rgba(0, 0, 0, 0.05)",
              borderRadius: "1.5px",
              padding: "0.5rem 3rem !important",
              "&:hover": {
                background: "#F9FAFB",
              },
            }}
            onClick={() => setIsMonitorMode(false)}
          >
            Save & Apply
          </SoftButton>
        </SoftBox>
      </Dialog>
    </>
  );
};

export default ExploreCustomMetricsTypes;
